import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from 'src/app/service/shared/shared.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { Config } from 'src/app/app-constant';
import { DatePipe } from '@angular/common';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { HttpService } from 'src/app/service/http/http.service';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { saveAs } from 'file-saver';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { CompetencyDictionaryPopupComponent } from 'src/app/shared/popups/competency-dictionary-popup/competency-dictionary-popup.component';
import { CompetencyAddNewComponent } from 'src/app/shared/popups/competency-add-new/competency-add-new.component';
import { MatSelectChange } from '@angular/material/select';
import * as echarts from 'echarts';
import { CompetecnyDashboardDetailsPopupComponent } from 'src/app/shared/popups/competecny-dashboard-details-popup/competecny-dashboard-details-popup.component';
import { ToastrService } from 'ngx-toastr'
import { environment } from 'src/environments/environment';
import { DownloadAsPdfService } from 'src/app/service/downloadAspdf/download-as-pdf.service';


interface Band {
  band: string;
}

interface Function {
  functions: string;
}
@Component({
  selector: 'app-competency-management',
  templateUrl: './competency-management.component.html',
  styleUrls: ['./competency-management.component.scss'],
})
export class CompetencyManagementComponent implements OnInit {
  employeesListComparisonSelected: any = [];
  comparisonEmployeesSelectMultiple: any=[];
  comparisonEmployeesSelectMultipleMangerView: any

  ComparisonEmployeeWiseEmp: string | null = null;
  selectedCompetencyForEmployeeDashboard: string = '';
  selectedCompetencyForEmployeeTableTeamGraphView: string = ''
  SelectCompetencyDropdownListForGraph: any= [];
  SelectCompetencyDropdownListForEmployeeTableTeamGraphView: any = [];
  ComparisonEmployeeWiseList: any = [];
  showMaxRangeError: boolean = false;
  allowedToEditTeamCompetency: boolean = false;
  allowedToEditManagerMycompetency: boolean = false;
  errorMessage: string = '';
  columnVisibility: { [key: string]: boolean } = {
    function: true,
    band: true,
    competencyName: true,
    competencyDefinition: true,
    weightage: true,
    publishedOn: true,
    createdBy: true,
    lastModifiedBy: true
  };
  chartOptions: echarts.EChartsOption | undefined;
  selectedEmployeeDashboardForGraph: any;
  selectedEmployeeDashboardId: any;
  selectedEmployeeDashboardFullName: any = [];
  userRoleExcelDownload: string = 'Manager'
  selectedCompetencyName: string | null = null;
  comparisonSelectedEmpIds: any[] = [];
  comparisonEmpIdsForSecondLast:any = [];
  yearOnYearEmployeesFinal: any[] = [];
  selectedEmpYearonYear: any= [];
  selectedYearForGraphTwoHRAdmin: any = null;
  selectedYearForGraphFifthHRAdmin: any = null;
  selectedYearForGraphSix: any = null;
  selectedYearForGraphNineHRAdmin: any = null;
  selectedYearForGraphTenHRAdmin: any = null;
  weightageWiseCompetenciesGraphData: any[] = [];
  graphDataForLineGraph: any[] = [];
  competencyYearOneYearData: any[] = []
  graphDataForCompetencyTrend: any[] = [];
  graphDataForCompetencyWiseEmployee: any[] = []
  graphDataForYearOnYearFinalScore: any[] = [];
  graphDataForRatingWiseEmployeeCount: any[] = [];
  graphDataForComparisonEmployeeWise: any[] = []
  managerViewEmpGraphList: any = [];
  selectedYearForMnagerGraphCompetencyWiseEmp: any = null;
  selectedEmployeeIdForManagerGraphView: any = [];
  managerEmpGraphListView: any = [];
  selectedManagerGraphEmpId: any;
  empManagerGraphTableData: any[] = [];
  managerEmpGraphTableData: any[] = [];
  selectedYearForGraphManagerViewRatingWise: any;
  selectedYearForGraphMangerViewComparison: any = null;
  ComparisonEmployeeWiseListManagerViewData: any = [];
  selectedCompetencyForComparison: any;
  employeesListComparisonSelectedManagerView: any = [];
  comparisonEmpIdsForSecondLastManagerView: any = [];
  setUpyearRange: any;
  totalReport: any=0;
  totalPagesReport: any=0;
  currentPageNumberReport: any=0;
  pageOfReport:any=0;
  searchStringReport:any;
  selectedSizeOfReport:any=25;
  loggedInCompanyMDCode: any;

  // Debugging function
  logColumnVisibility() {
  }

  onCheckboxChangeCheck(column: string, event: any) {
    this.columnVisibility[column] = event.checked;
    this.logColumnVisibility(); // Debugging call
  }

  checkboxState: { [key: string]: boolean } = {
    function: true,
    band: true,
    competencyName: true,
    competencyDefinition: true,
    weightage: true,
    publishedOn: true,
    createdBy: true,
    lastModifiedBy: true
  };

  competencyMapping: any = null;
  previousMaxRange: string = '0';
  showInputs: boolean = false;
  employeetotalweight: number[] = [];
  hradminCompetency: any[] = [];
  scoreRange: number | any;
  dropdownSettings: IDropdownSettings = {};
  maxRange: number | any = null;
  setupSubRatingId: any
  rating: string = '';
  ratings: string[] = [];
  isDuplicateRating: boolean = false;
  competencyYear: any;
  tableData: { scoreRange: string; maxRange: string; rating: string,id: null }[] = [];
  evaluationPeriod: any = null;
  editIndex: number | null = null;
  setupForm: boolean = false
  selectedTypeTabIndex = 0;
  selectedTypeTabName = 'Dashboard'
  buttonColorName: any;
  subModuleButtonColor: any;
  showSetupPopup: boolean = false;
  showImportPopup: boolean = false;
  currentDate: any = new Date;
  competencyemployee: any = [];
  toDate: any;
  fromDate: any;
  selectedFunction: string = '';
  selectedBands: any[] = [];
  selectedBandForManager: string[] = [];
  uniqueFunctions: any[] = [];
  uniqueBands: any[] = [];
  competencySetupInformationForm: FormGroup = new FormGroup({});
  loggedInUserCompanyID: any;
  startItemhr: number = 0;
  endItemhr: number = 0;
  selectedYearForCompetency: any = null;
  selectedYearForGraphOneHRAdmin: any = null;
  editedIndex: number | null = null;
  editedEmployeeCommentIndex: number | null = null;
  selectedOption: string = 'Top';

  scoreRangeArray: any = [
    {
      companyId: null,
      id: null,
      maxRange: null,
      minRange: null,
      normalizeScore: null,
      pmsSetupId: null
    }
  ]
  loggedInCompanyFiscalyear: any;
  companyHODList: any = [];
  numbersOfDaysArray = Array.from({ length: 6 }, (_, i) => i + 1);
  columnHeaderVisiableData: any = [];
  columnHeaderAllData: any = [];
  columnHeaderHideShowAllData: any = [];
  editPMSSetUp: boolean = false;
  addedScores: any = [];
  kpiDataListByUser: any = [];
  loggedInUserId: any;
  loggedInUserName: any
  teamOfManagerList: any = [];
  selectedUserForKPISearch: any;
  selectedSizeToShowData: number = 25;
  selectedSizeOfPMS: any = 25;
  getAllkpiIDsList: any = [];
  goalApprovalStatus: boolean = false;
  goalReviewStatus: boolean = false;
  allReviewAreApproved: boolean = false;
  loggedInUserRole: any;
  loggedInManagerName: any;
  totalWeightage: any = 0;
  totalKpiScore: any = 0;
  selectAllCheckbox: boolean = false;
  searchString: any = null;
  selectedManagerFunctions: any[] = [];
  itemsPerPage: number = 10;
  totalPagesOfKpi: any = 0;
  totalKpis: any = 0;
  currentPageNumberOfKpis: any = 1;
  page: any = 0;
  loggedInUserRoles: any;
  loggedInUserRoleIsEmployee: boolean = false;
  pmsYears: any = [];
  getMonthsByFiscalandReviewCycle: any = [];
  fromYear: any = null;
  toYear: any = null;
  selectedItemsForPublish: Set<number> = new Set<number>();
  selectedItemsForDelete: Set<number> = new Set<number>();
  loggedInCompanyReviewCycle: any = null;
  deptListOfCompany: any;
  selectedDeptForKPISearch: any = null;
  goalSettingAtAllLevels: boolean = false;
  selectedYearReviewCycle: any;
  activeCustomReportBtn: boolean = false;
  isAllEmpForReportToggle: boolean = false;
  selectedGoalForEmp: any;
  selectedUserForKPIReport: any;
  activeReportBtnName: any = 'Scorecard';
  showTooltip: boolean = false;
  competencyList: any = [];
  competencyListManagerView: any = []
  showFunction = true;
  showBand = true;
  showCompetencyName = true;
  showCompetencyDefinition = true;
  showWeightage = true;
  showPublishedOn = true;
  showCreatedBy = true;
  showLastModifiedBy = true;
  checkboxVisibility = {
    function: true,
    band: true,
    competencyName: true,
    competencyDefinition: true,
    weightage: true,
    publishedOn: true,
    createdBy: true,
    lastModifiedBy: true

  };

  reportBtn = [
    {
      isActive: true,
      btnName: 'Scorecard'
    },
    {
      isActive: false,
      btnName: 'All Employee -Month-YTD'
    },
    {
      isActive: false,
      btnName: 'KPI wise YTD'
    },
    {
      isActive: false,
      btnName: 'Review Compliance Report'
    },
    {
      isActive: false,
      btnName: 'Review Compliance Summary'
    },
    {
      isActive: false,
      btnName: 'Custom Report'
    },
  ]
  isAnyColumnInvisible: boolean = false;
  isAllReviewStatusNotApproved: boolean = false;
  monthsForScoreCardReport: any = [];
  employeesScoreCardReportData: any = [];
  selectedReviewCycle: any = [];
  searchKpiReportString: any;
  customReportData: any = [];
  sleectedUserforCompetencySetup: any;
  loggedInUserEmpCode: any;
  formattedYear: any;
  employeelistUnderManager: any = [];
  employeelistUnderManagerGraphHrAdminEMP: any = []
  editableColumns = new Set<string>();
  isEditing: any;
  originalData: any[] = [];
  currentPage: number = 0;
  totalPages: number = 0;
  totalItems: number = 0;
  pageSize: number = 25;
  dropdownData: any[] = [];
  selectedFunctionsForHrAdmin: any = [];
  bands: any[] = [];
  employeeList: any[] = [];
  selectedEmployees: any = [];
  selectedEmployeeIds: any[] = [];
  selectedEmployee: any;

  reportData: any = [];
  employeeReport: any = [];
  reportDataList: any[] = [];
  managerfunctionlist: any[] = [];
  setupId: any;
  totalWt: any;
  totalScore: any;
  selectedEmployeeIdsManager: number[] = [];
  isMaxRangeReached = false;
  setupGradeBrand: any;
  managerBandSelected: any = [] = [];
  managerFunctionsList: any = [];
  managerBandList: any[] = [];
  ManagerBandListByGrade: any = [];
  selectedManagers: any = [];
  MbandList: any = [];
  selectedEmployeesManager: any[] = [];
  ManagerEmployeeIds: number[] = [];
  restrictToEditBandOrGrade: boolean = false;
  functionsListHrAdminData: any = [];
  bandListHrAdmin: any[] = [];
  gradeListHrAdmin: any[] = [];
  selectedValue: string[] = [];
  selectedHrAdminFunction = '';
  public restrictToEditSetup: boolean = false;
  cd: any;
  ManagerDropdownDataReportManager: any[] = [];
  selectedEmployeeId: string | null = null;
  hradminCompetencyAllowToEdit: boolean = false;
  isInValidMaxRange: boolean = false;
  //dashboard
  managerListDashboardHrAdmin: any = [];
  selectedManagerDashboardHrAdmin: any
  selectedManagerDashboardId: any;
  employeelistUnderManagerGraphHrAdmin: any;
  employeeUnderManagerHrAdmingraph: any;
  selectedEmployeeIdForScoreAndRating: any;
  competencyWiseEmployeeDataForTable: any[] = [];
  isSelectedYearIsSameYeartoCurrentYear: boolean = false;
  isShowAddBtn:boolean = false;
  selectedTabIndex: number = 0
  constructor(public sharedService: SharedService,
    private loader: LoaderService, private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog, private datePipe: DatePipe,
    private activatedroute: ActivatedRoute,private toastr:ToastrService,
    private pdfDownload: DownloadAsPdfService
  ) {
    this.scoreRange = '0';
  }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    const loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if(loggedInUserEmpCode == 'null'){
      this.loggedInUserEmpCode = null
    }else { 
      this.loggedInUserEmpCode = loggedInUserEmpCode 
    }
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    this.updateYearControl(this.loggedInCompanyFiscalyear);
    this.getAllFunctionsByYearRangeReport();
    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == "Employee") {
          this.loggedInUserRoleIsEmployee = true
        }
      }      
    }


    // this.getFunctionList()
    // this.getBandFunctionList();
    this.initilaizeCompetencySetupForm();
    this.originalData = JSON.parse(JSON.stringify(this.competencyListManagerView));
    this.calculateScoresEmployeeList();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'itemName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    // this.getAllFunctionsByYearRangeReport();

  }


  ionViewWillEnter() {
    this.activatedroute.params.subscribe((params: any) => {
      
      var tab = params['tab'];
      if (tab === 'My Competency') {
        this.selectedTypeTabName = 'My Competency'
        this.selectedTypeTabIndex = 1;
        this.getAllEmployeesUnderManagerView();
      };

      if (params?.operation === 'Setup') {
        if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
          || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
          this.showSetupPopup = true;
          this.updateYearControl(this.loggedInCompanyFiscalyear);
          this.getPmsYears();
        }
      } else if (params?.operation === 'import') {
        if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
          || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
          this.showImportPopup = true;
        }
      } else {
        if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
          || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
          this.getDepartmentsByCompany();
        }else{
          this.selectedEmployeeDashboardId=this.loggedInUserId;
          this.getUserByID();
        }
        this.getCompetencySetupYearOfCompany()
      }
    });
  }

  tabTypeChanged(event: MatTabChangeEvent): void {
    
    this.selectedTypeTabName = event.tab.textLabel;
    this.selectedTypeTabIndex = event?.index
    this.page = 0;
    this.errMsgForTotal = null;
    this.errMsgDuplicateNameandDef = null;
    this.indexOfErrMsgWtTotal = null;
    this.indexOfErrMsgDuplicateNameandDef = null;
    this.indexOfErrMsgDuplicateDeptandBand = null;
    this.errMsgDuplicateDeptandBand = null;
    if (this.selectedTypeTabName === 'My Competency') {
      this.getAllEmployeesUnderManagerView();
    } else if (this.selectedTypeTabName === 'Competency Master') {
      this.getAllCompetencyList();
    }
    else if (this.selectedTypeTabName === 'Team Competency') {
      this.getCompetencyByManagerTeamList();
    } else if (this.selectedTypeTabName === 'Reports') {
      this.reportDataList = [];
      this.totalItems = 0;
      this.currentPage = 0;
      if (this.loggedInUserRole === 'Employee') {
        this.submitData()
      }else if (this.loggedInUserRole === 'Manager' || this.loggedInUserRole === 'HOD'){
        this.selectedManagerFunctions = [];
        this.selectedBands = [];
        this.selectedEmployeesManager = [];
        this.getFunctionListManager();
      }else{
        this.selectedFunctionsForHrAdmin = [];
        this.bandListHrAdmin = [];
        this.selectedEmployees = [];
        this.getDepartmentsByCompany();
      }
    }else if (this.selectedTypeTabName === 'Dashboard') {
      this.getLoginUserGraphData();
    }
  }

  toggleVisibility(column: string) {
    this.columnVisibility[column] = !this.columnVisibility[column];
  }


  onCheckboxChangeApply(column: string, event: any) {
    this.checkboxState[column] = event.checked;
    this.columnVisibility[column] = event.checked;
  }


  removeInputs() {
    this.showInputs = false;
    this.resetFormFields();
  }
  resetFormFields() {
    this.scoreRange = null;
    this.maxRange = null;
    this.rating = '';
    this.isInValidMaxRange = false;
  }

  applyFilters(): void {
  }

  onRatingChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const value = inputElement.value;
    this.rating = value.replace(/[^a-zA-Z]/g, '');
    inputElement.value = this.rating;
  }





  onMaxRangeChange(data: { maxRange: number | string; minRange: number }): void {
    
    if(this.maxRange == null){
      this.errMsgMaxRange = true;
      return;
    }else{
      this.errMsgMaxRange = false;
    }
    const maxRange = typeof data.maxRange === 'string' ? Number(data.maxRange) : data.maxRange;
    const minRange = data.minRange;
    if (isNaN(maxRange) || maxRange <= minRange || maxRange <= 0) {
      this.isInValidMaxRange = true;
      this.maxRange = null;
    } else {
      this.isInValidMaxRange = false;
    }
  }




  checkRating(value: string) {
    this.rating = value.replace(/[^a-zA-Z0-9 ]/g, '').trim();
    this.isDuplicateRating = this.ratings.includes(this.rating);
    if (!this.isDuplicateRating) {
      this.ratings.push(this.rating);
    }
  }



  downloadData() {
    if (this.selectedTypeTabName === 'My Competency') {
      this.downloadEmployeeData();
    } else if (this.selectedTypeTabName === 'Competency Master') {
      this.downloadHRAdminData();
    }
    else if (this.selectedTypeTabName === 'Team Competency') {
      this.downloadManagerData();
    }
  }

  downloadManagerData() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      employeeId: this.selectedEmployeeId,
      managerCode: this.loggedInUserEmpCode,
      yearRange: this.selectedYearForCompetency,
      searchString: this.searchString
    };
    this.httpService.callPostService(this.config.getCompetencyExcelTableData, request).subscribe(
      (data: any) => {
        if(data?.data!=null){
          var fileName = data?.data?.split(environment.downloadURL)
          saveAs(data?.data, fileName[1]); 
        }
      },
      (error) => {
      }
    );
  }




  downloadEmployeeData() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      employeeId: this.loggedInUserId,
      managerCode: this.loggedInUserEmpCode,
      yearRange: this.selectedYearForCompetency,
      searchString: this.searchString
    };

    this.httpService.callPostService(this.config.getCompetencyEmployeeExcelTableData, request).subscribe(
      (data: any) => {
        if (data?.data) {
          const fileUrl = data.data;
          const fileName = fileUrl.split('/').pop();

          if (fileName) {
            saveAs(fileUrl, fileName);
          } else {
          }
        } else {
        }
      },
      (error) => {
      }
    );
  }

  downloadHRAdminData() {
    var searchString = 'All';
    if (this.searchString == null) {
      searchString = 'All';
    } else {
      searchString = this.searchString;
    }
    this.httpService.callGetService(this.config.getCompetencyHrAdminTableData + this.loggedInUserCompanyID + '/' + searchString + '/' + this.selectedYearForCompetency).subscribe(
      (data: any) => {
        if(data?.data!=null){
          var fileName = data?.data?.split(environment.downloadURL)
          saveAs(data?.data, fileName[1]); 
        }
      },
      (error) => {
      }
    );
  }




  deleteSetup() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Do you really want to delete these ratings?',
        btn1: 'Cancel',
        btn2: 'Delete',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if(this.setupId == null){
          this.tableData = []
        }else{
          this.httpService.callGetService(this.config.deleteSetupTable + this.loggedInUserCompanyID + '/' + this.setupId)
          .subscribe(
            (response: any) => {
              this.loader.dismissLoader();
    
              const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                width: '30%',
                data: {
                  msg: 'Items successfully deleted.',
                  btn2: 'OK',
                  btn2BgColor: this.buttonColorName,
                  showSuccessIcon: true,
                  showSuccessMessage: false,
                  showCloseIcon: false,
                },
              });
              successdialogRef.afterClosed().subscribe(() => {
                this.getCompetencySetup()
              });
    
            },
            (error: any) => {
            }
          );
        }
      }
    });
  }



  // getFunctionList() {
  //   this.httpService.callGetService(this.config.getCompetencyFunctionAndBandList + this.loggedInUserCompanyID)
  //     .subscribe((data: any) => {
  //       const competencyFunctionAndBandList = data?.data;
  //       this.uniqueFunctions = competencyFunctionAndBandList?.uniqueFunctions || [];
  //       this.uniqueBands = competencyFunctionAndBandList?.uniqueBands || [];
  //     });
  // }
  onCheckboxChange(event: any, item: any) {
    if (event.checked) {
      this.selectedItemsForPublish.add(item.id);
    } else {
      this.selectedItemsForPublish.delete(item.id);
    }
  }
  selectALLRecords(event: any) {
    if (event.checked) {
      this.selectedItemsForPublish.clear();
      this.selectedItemsForDelete.clear();
      this.selectAllCheckbox = true;
      for (let i = 0; i < this.hradminCompetency.length; i++) {
        if (!this.hradminCompetency[i].published) {
          this.hradminCompetency[i].checkboxCheck = true;
          this.selectedItemsForPublish.add(this.hradminCompetency[i].id)
        }
        if(!this.hradminCompetency[i].allowedToEditDelete) {
          this.hradminCompetency[i].checkboxCheck = true;
          this.selectedItemsForDelete.add(this.hradminCompetency[i].id)
        }
      }
    } else {
      for (let i = 0; i < this.hradminCompetency.length; i++) {
        this.hradminCompetency[i].checkboxCheck = false;
      }
      this.selectAllCheckbox = false;
      this.selectedItemsForPublish.clear();
      this.selectedItemsForDelete.clear();
    }
  }
  selectSingleRecord(event: any, data: any, index: any) {
    
    if (event.checked) {
      this.hradminCompetency[index].checkboxCheck = true;
      if (!data.published) {
        this.selectedItemsForPublish.add(data.id);
      }
      if (!data.allowedToEditDelete) {
        this.selectedItemsForDelete.add(data.id);
      }
    } else {
      this.selectAllCheckbox = false;
      this.hradminCompetency[index].checkboxCheck = false;
      this.hradminCompetency.forEach((ele: any, ind: any) => {
        if (ele.checkboxCheck == false) {
          this.selectedItemsForPublish.forEach((ele1: any, ind1: any) => {
            if(ele1 == ele.id){
              this.selectedItemsForPublish.delete(ind1);
            }
          })
          this.selectedItemsForDelete.forEach((ele2: any, ind2: any) => {
            if(ele2 == ele.id){
              this.selectedItemsForDelete.delete(ind2);
            }
          })
        }
      })
      if(this.selectedItemsForPublish.size==0 || this.selectedItemsForDelete.size==0){
        this.selectAllCheckbox = false;
        this.selectedItemsForPublish.clear();
        this.selectedItemsForDelete.clear();
      }
    }
  }
  areItemsSelected(): boolean {
    return this.selectedItemsForPublish.size > 0;
  }


  get anyItemSelected(): boolean {
    return this.selectedItemsForPublish.size > 0;
  }

  getEmployeeListOnGoal() {
    this.teamOfManagerList = [];
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "from": null,
      "fromYear": this.fromYear,
      "to": null,
      "toYear": this.toYear,
      "userId": this.loggedInUserId,
      "userType": null
    }
    this.httpService.callPostService(this.config.getTeamOfManagerByDate, request).
      subscribe((data: any) => {
        data?.data?.forEach((ele: any) => {
          let obj = {
            id: ele?.id,
            name: ele?.firstName + ' ' + ele?.lastName,
          }
          this.teamOfManagerList.push(obj);
        });
        this.teamOfManagerList = this.teamOfManagerList.sort((a: any, b: any) => a.name.localeCompare(b.name));
      })
  }


  toggleColumn(column: string) {
    switch (column) {
      case 'function':
        this.showFunction = !this.showFunction;
        break;
      case 'band':
        this.showBand = !this.showBand;
        break;
      case 'competencyName':
        this.showCompetencyName = !this.showCompetencyName;
        break;
      case 'competencyDefinition':
        this.showCompetencyDefinition = !this.showCompetencyDefinition;
        break;
      case 'weightage':
        this.showWeightage = !this.showWeightage;
        break;
      case 'publishedOn':
        this.showPublishedOn = !this.showPublishedOn;
        break;
      case 'createdBy':
        this.showCreatedBy = !this.showCreatedBy;
        break;
      case 'lastModifiedBy':
        this.showLastModifiedBy = !this.showLastModifiedBy;
        break;
    }
  }

  allowedToEditDelete:boolean=false;
  getAllCompetencyList() {
    var searchString = 'All';
    if (this.searchString == null) {
      searchString = 'All';
    } else {
      searchString = this.searchString;
    }
    
    this.httpService.callGetService(this.config.getAllCompetencyList + this.loggedInUserCompanyID + '/' + searchString + '/' + this.selectedYearForCompetency
      + '?page=' + this.page + '&size=' + this.selectedSizeOfPMS)
      .subscribe((response: any) => {
        this.selectAllCheckbox = false;
        this.selectedItemsForPublish.clear();
        this.selectedItemsForDelete.clear();
        
        if (response && response.data && response.data.data) {
          this.hradminCompetency = response.data.data.map((item: any) => ({
            ...item,
            formattedPublishedOn: this.datePipe.transform(item.publishedOn, 'dd-MM-yyyy | hh:mm a'),
            formattedCreatedAt: this.datePipe.transform(item.createdAt, 'dd-MM-yyyy | hh:mm a'),
            formattedLastModifiedOn: this.datePipe.transform(item.lastModifiedOn, 'dd-MM-yyyy | hh:mm a'),
            published: item.published
          }));
          this.allowedToEditDelete = this.hradminCompetency?.every((ele: any) => !ele.allowedToEditDelete);
          this.hradminCompetencyAllowToEdit = response.data?.allowedToEdit;
          this.uniqueBands = this.extractUniqueBands(this.hradminCompetency);
          this.uniqueFunctions = this.extractUniqueFunctions(this.hradminCompetency);
          this.totalItems = response.data.total;
          this.totalPages = response.data.totalPages;
          this.currentPage = response.data.currentPageNumber;
          this.updatePagination();
        } else {
          this.hradminCompetency = [];
          this.totalItems = 0;
          this.totalPages = 0;
          this.currentPage = 0;
        }
      }, (error) => {
        this.hradminCompetency = [];
        this.totalItems = 0;
        this.totalPages = 0;
      });
  }


  extractUniqueFunctions(data: any[]): any[] {
    const functions = data.map(item => item.functionName);
    return Array.from(new Set(functions)).map(func => ({ functions: func }));
  }
  extractUniqueBands(data: any[]): any[] {
    const bands = data.map(item => item.band);
    return Array.from(new Set(bands)).map(band => ({ band }));
  }


  publish() {
    const companyId = this.loggedInUserCompanyID;
    const selectedCompetencyIds = Array.from(this.selectedItemsForPublish);
    const selectedYearForCompetency = this.selectedYearForCompetency

    if (selectedCompetencyIds.length === 0) {
      return;
    }

    const request = {
      companyId: companyId,
      competencyIds: selectedCompetencyIds,
      yearRange: this.selectedYearForCompetency,
    };

    this.loader.simpleLoader();
    this.httpService.callPostService(this.config.publishedCompetency, request).subscribe((data: any) => {
      this.loader.dismissLoader();
      if (data?.status) {
        this.selectAllCheckbox=false;
        const successMessage = data.message;
        const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: successMessage, // Pass the success message
            btn2: 'OK',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: true,
            showSuccessMessage: true,
            showCloseIcon: false,
          },
        });
        successdialogRef.afterClosed().subscribe(() => {
          // this.router.navigate(['/home/hrportal/competency']);
          this.getAllCompetencyList();
          this.clearInputs();
          this.selectedItemsForPublish.clear();
          this.selectedItemsForDelete.clear();
          this.getCompetencySetup();
        });
      } else {
      }
    }, error => {
      this.loader.dismissLoader();
    });
  }

  getTotalWeightage(competencyMasterlist: any[]): number {
    if (!Array.isArray(competencyMasterlist)) {
      return 0;
    }
    return competencyMasterlist?.reduce((total, comp) => total + (comp.weightageNo || 0), 0);
  }


  onSelectYearForCompetencySetup() {
    
    var year = this.competencySetupInformationForm.value.year?.split('-');
    if (year && year.length === 2) {
      const fromYear = year[0];
      const toYear = year[1];
      this.competencySetupInformationForm.controls['fromYear'].setValue(fromYear);
      this.competencySetupInformationForm.controls['toYear'].setValue(toYear);
    }
    this.getCompetencySetup();
    // this.getAllCompetencyList();
    // this.calculateScoresEmployeeList();
    // this.getAllFunctionsByYearRangeReport();
    // this.reportDataList = [];
    // this.managerFunctionsList = [];
    // this.selectedEmployeeId = null;
    // this.getAllEmployeesUnderManagerView();
    // this.employeelistUnderManager = [];
    // this.competencyListManagerView = [];
    // this.getCompetencyByManagerTeamList();
    // this.getFunctionListManager();
    // this.getEmployeeUnderManager();
  }

  onSelectYearForCompetencyForOther() {
    
    var year = this.competencySetupInformationForm.value.year?.split('-');
    if (year && year.length === 2) {
      const fromYear = year[0];
      const toYear = year[1];
      this.competencySetupInformationForm.controls['fromYear'].setValue(fromYear);
      this.competencySetupInformationForm.controls['toYear'].setValue(toYear);
    }
    if (this.loggedInCompanyFiscalyear != null) {
      this.selectedYearForGraphOneHRAdmin = this.selectedYearForCompetency
      this.selectedYearForGraphTwoHRAdmin = this.selectedYearForCompetency
      this.selectedYearForGraphFifthHRAdmin = this.selectedYearForCompetency
      this.selectedYearForGraphSix = this.selectedYearForCompetency
      this.selectedYearForGraphNineHRAdmin = this.selectedYearForCompetency
      this.selectedYearForGraphTenHRAdmin = this.selectedYearForCompetency
      var years = this.selectedYearForCompetency?.split('-');
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth(); // 0 for January, 11 for December
      const currentYear = currentDate.getFullYear();
      var endMonth = this.loggedInCompanyFiscalyear?.split('_')
      const monthToCheck = new Date(years[1], this.getMonthIndex(this.sharedService.transform(endMonth[1])), 30);
      this.isShowAddBtn = currentDate < monthToCheck;
    } else {
      this.isShowAddBtn = false;
    }
    this.getCompetencySetup();
    this.calculateScoresEmployeeList();
    this.getAllFunctionsByYearRangeReport();
    this.reportDataList = [];
    this.managerFunctionsList = [];
    this.selectedEmployeeId = null;
    this.employeelistUnderManager = [];
    this.competencyListManagerView = [];
    
    if (this.selectedTypeTabName === 'Dashboard') {
      if(this.loggedInUserRole == 'Manager'|| this.loggedInUserRole == 'HOD'){
        this.getEmployeeUnderManager();
      }
      if(this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin'
        || this.loggedInUserRole == 'MD'){
          this.getManagerListDashboard();
      }
    }else if (this.selectedTypeTabName === 'Reports') {
      this.reportDataList = [];
      this.totalItems = 0;
      this.currentPage = 0;
      if (this.loggedInUserRole === 'Employee') {
        this.submitData()
      }else if (this.loggedInUserRole === 'Manager' || this.loggedInUserRole === 'HOD'){
        this.selectedManagerFunctions = [];
        this.selectedBands = [];
        this.selectedEmployeesManager = [];
        this.getFunctionListManager();
      }else{
        this.selectedFunctionsForHrAdmin = [];
        this.bandListHrAdmin = [];
        this.selectedEmployees = [];
        this.getDepartmentsByCompany();
      }
    }else{
      if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
        || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
          this.getManagerListDashboard();
      } 
    }
    if (this.selectedTypeTabName === 'My Competency') {
      this.getAllEmployeesUnderManagerView();
    } else if (this.selectedTypeTabName === 'Competency Master') {
      this.getAllCompetencyList();
    }
    else if (this.selectedTypeTabName === 'Team Competency') {
      this.getEmployeeUnderManager();
      this.getCompetencyByManagerTeamList();
    }
    this.getDepartmentsByCompany();
  }


  deleteCompetency() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to delete?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const companyId = this.loggedInUserCompanyID;
        const selectedCompetencyIds = Array.from(this.selectedItemsForDelete);
        if (selectedCompetencyIds.length === 0) {
          return;
        }
        const request = {
          companyId: companyId,
          competencyIds: selectedCompetencyIds
        };
        this.loader.simpleLoaderWithDuration();
        this.httpService.callPostService(this.config.deleteCompetency, request).subscribe(
          (data: any) => {
            this.loader.dismissLoader();
            if (data?.success) {
              const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                width: '30%',
                data: {
                  msg: data?.data,
                  btn2: 'OK',
                  btn2BgColor: this.buttonColorName,
                  showSuccessIcon: true,
                  showSuccessMessage: false,
                  showCloseIcon: false,
                },
              });
              successdialogRef.afterClosed().subscribe(() => {
                this.getAllCompetencyList(); // Refresh the list after deletion
                this.clearInputs();
                this.selectedItemsForPublish.clear();
                this.selectedItemsForDelete.clear();
              });
            } else {
              this.loader.dismissLoader();
            }
          },
          error => {
            this.loader.dismissLoader();
          }
        );
      }
    });
  }

  handleSubmit() {

    if (!this.isLastMaxRange100()) {
      this.errorMessage = 'The setup must include a max range of 100.';
      return;
    }
    if (!this.competencyMapping || !this.evaluationPeriod) {
      alert('Please select both Competency Mapping and Evaluation Period before submitting.');
      return;
    }
    this.saveData();
    this.setCompetency();
  }



  setCompetency() {
    if (this.selectedTypeTabName == 'Dashboard') {
      this.sleectedUserforCompetencySetup = this.loggedInUserId;
    }
    const request = {
      competencyEvaluationPeriod: this.evaluationPeriod,
      companyId: this.loggedInUserCompanyID,
      rating: this.tableData.map(data => ({
        max: parseInt(data.maxRange, 10),
        min: parseInt(data.scoreRange, 10),
        rating: data.rating,
        companyId: this.loggedInUserCompanyID,
        id: data.id
      })),
      selectCompetency: this.competencyMapping,
      "year": this.selectedYearForCompetency,
      "id": this.setupId 
    };

    this.loader.simpleLoaderWithDuration();
    this.httpService.callPostService(this.config.competecnySetup, request).subscribe((data: any) => {
      this.loader.dismissLoader();
      if (data?.success) {
        const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: data.data,
            btn2: 'OK',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: true,
            showSuccessMessage: false,
            showCloseIcon: false,
          },
        });
        successdialogRef.afterClosed().subscribe(() => {
          this.router.navigate(['/home/hrportal/competency']);
        });
        this.clearInputs();
      }
    });
  }
  logEvaluationPeriod() {
  }
  logRadioSelection(value: string) {
    this.competencyMapping = value;
  }
  logInputChanges() {

  }

  CompetencyYear() {
    this.competencyYear = `${this.fromYear} - ${this.toYear}`;
  }






  getCompetencySetup() {
    this.httpService.callGetService(this.config.getCompetencySetupById + this.loggedInUserCompanyID + '/' + this.selectedYearForCompetency)
      .subscribe((response: any) => {
        const currentYear = new Date().getFullYear();
        
        if (this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
          this.isSelectedYearIsSameYeartoCurrentYear = true;
        } else {
          var year = this.selectedYearForCompetency?.split('-');
          if (Number(year[0]) >= currentYear
            || Number(year[1]) >= currentYear) {
            if (this.loggedInCompanyFiscalyear != null) {
              const currentDate = new Date();
              const currentMonth = currentDate.getMonth(); // 0 for January, 11 for December
              const currentYear = currentDate.getFullYear();

              var endMonth = this.loggedInCompanyFiscalyear?.split('_')
              const monthToCheck = new Date(year[1], this.getMonthIndex(this.sharedService.transform(endMonth[1])), 30);
              this.isSelectedYearIsSameYeartoCurrentYear = currentDate < monthToCheck;
            } else {
              this.isSelectedYearIsSameYeartoCurrentYear = false;
            }
          } else {
            this.isSelectedYearIsSameYeartoCurrentYear = false;
          }
        }
        const getCompetencySetup = response?.data;
        
        if (getCompetencySetup) {
          this.setupGradeBrand = getCompetencySetup.selectcompetency;
          this.competencyMapping = getCompetencySetup.selectcompetency;
          this.evaluationPeriod = getCompetencySetup.competencyEvaluationPeriod;
          this.setupId = getCompetencySetup.id;
          this.tableData = getCompetencySetup.rating.map((item: any) => ({
            scoreRange: item.min,
            maxRange: item.max,
            rating: item.rating,
            id: item.id
          }));
          if (!this.isSelectedYearIsSameYeartoCurrentYear) {
            this.restrictToEditBandOrGrade = true;
            this.restrictToEditSetup = true;
          } else {
            this.restrictToEditBandOrGrade = getCompetencySetup.restrictToEditBandOrGrade;
            this.restrictToEditSetup = getCompetencySetup.restrictToEditSetup;
          }
          this.setUpyearRange = getCompetencySetup.yearRange
        } else {
          this.tableData = [];
          if (!this.isSelectedYearIsSameYeartoCurrentYear) {
            this.restrictToEditBandOrGrade = true;
            this.restrictToEditSetup = true;
          } else {
            this.restrictToEditBandOrGrade = false;
            this.restrictToEditSetup = false;
          }
          this.setUpyearRange = null;
          this.evaluationPeriod = null;
          this.setupId = null;
          this.setupGradeBrand = null;
          this.competencyMapping = null;
        }
      });
  }

  deleteSetupRecords() {

  }


  initilaizeCompetencySetupForm() {
    this.competencySetupInformationForm = this.fb.group({
      competencyMapping: [''],
      scoreRange: [''],
      maxRange: [''],
      rating: [''],
      year: [''],
      fromYear: [''],
      toYear: [''],
      competencyEvaluationPeriod: ['']
    });
  }
  toggleInputs() {
    if (this.showInputs) {
      this.logInputChanges();
      this.saveData();
    } else {
      if (this.isLastMaxRange100()) {
        alert("Max Range of 100 already reached. You cannot add more ranges.");
        return;
      }
      this.scoreRange = this.tableData.length > 0 ? this.tableData[this.tableData.length - 1].maxRange.toString() : '0';
    }

    this.showInputs = !this.showInputs;
  }





  isLastMaxRange100(): boolean {
    // Ensure tableData is not empty
    if (this.tableData.length === 0) {
      return false;
    }

    // Get the maxRange of the last item in the tableData array
    const lastMaxRange = Number(this.tableData[this.tableData.length - 1].maxRange);

    // Return true if maxRange is 100, otherwise false
    return lastMaxRange === 100;
  }

  preventNegative(event: KeyboardEvent): void {
    if (event.key === '-' || event.key === 'e' || event.key === '+') {
      event.preventDefault();
    }
  }

  errMsgMaxRange:boolean=false;
  saveData() {
    
    this.showMaxRangeError = false;

    const scoreRangeStr = this.scoreRange ? this.scoreRange.trim() : '';
    const ratingStr = this.rating ? this.rating.trim() : '';
    
    if(this.maxRange == null){
      this.errMsgMaxRange = true;
    }else{
      this.errMsgMaxRange = false;
    }
    if (!scoreRangeStr || this.maxRange === null || this.maxRange === undefined || !ratingStr) {
      this.errMsgMaxRange = true;
      return;
    }
    const maxRangeNum = parseFloat(this.maxRange.toString());

    // Check if maxRange exceeds 100
    if (maxRangeNum > 100) {
      alert('Validation failed: max Range cannot exceed 100.');
      return;
    }
    if (maxRangeNum == 100) {
      this.errorMessage = '';
    }
    // Check if there is already an entry with maxRange 100
    const hasMaxRange100 = this.tableData.some(data => parseFloat(data.maxRange) === 100);

    if (hasMaxRange100 && maxRangeNum !== 100) {
      alert('Cannot add this entry. An entry with maxRange 100 already exists.');
      return;
    }

    // Check if the last entered maxRange is 100
    if (this.isLastMaxRange100() && maxRangeNum !== 100) {
      alert('Validation failed: The maximum range must be 100 to proceed.');
      return;
    }

    // Check for duplicate rating
    const duplicateRating = this.tableData.some(data => data.rating.toLowerCase() === ratingStr.toLowerCase());
    if (duplicateRating) {
      alert('Duplicate rating found. Please enter a different rating.');
      return;
    }

    // Add new data to tableData
    this.tableData.push({
      scoreRange: scoreRangeStr,
      maxRange: this.maxRange,
      rating: ratingStr,
      id: null
    });

    // Reset the input fields and hide the input section
    this.scoreRange = '';
    this.maxRange = null;
    this.rating = '';
    this.showInputs = false;
  }













  clearInputs() {
    this.scoreRange = '';
    this.maxRange = null;
    this.rating = '';
  }



  editRow(index: number) {
    const entry = this.tableData[index];
    this.scoreRange = entry.scoreRange;
    this.maxRange = entry.maxRange;
    this.rating = entry.rating;
    this.editIndex = index;
    this.showInputs = true;
  }

  deleteRow(index: number) {
    this.tableData.splice(index, 1);
    this.clearInputs();
  }

  toggleTooltip() {
    this.showTooltip = !this.showTooltip;
  }



  onClickSetup(operation: any) {
    this.router.navigate(['/home/hrportal/competency', { operation: operation }]);
  }

  onClickImport(operation: any) {
    this.router.navigate(['/home/hrportal/competency', { operation: operation }]);
  }



  onClickBreadcrumPMS() {
    this.router.navigate(['/home/hrportal/competency']);
  }

  updateYearControl(fiscalYear: string): void {
    // const currentYear = new Date().getFullYear();
    // let yearValue = '';
    // if (fiscalYear === 'Jan_Dec') {
    //   yearValue = `${currentYear}-${currentYear}`;
    //   this.pmsSetupInformationForm.controls['fromYear'].setValue(currentYear);
    //   this.pmsSetupInformationForm.controls['toYear'].setValue(currentYear);
    //   this.pmsSetupInformationForm.controls['year'].setValue(yearValue);

    // } else {
    //   yearValue = `${currentYear}-${currentYear + 1}`;
    //   this.pmsSetupInformationForm.controls['fromYear'].setValue(currentYear);
    //   this.pmsSetupInformationForm.controls['toYear'].setValue(currentYear + 1);
    //   this.pmsSetupInformationForm.controls['year'].setValue(yearValue);
    // }
    // this.getetUpByID();
  }

  setup() {
    this.setupForm = true;
  }

  competencyDictionaryPopup() {
    if (this.selectedTypeTabName == 'Competency Master') {
      this.selectedUserForKPISearch = this.loggedInUserId;
    }
    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.data = {
      operation: 'Add',
      selectedTab: this.selectedTypeTabName,
      selectedUserID: this.selectedUserForKPISearch,
      fromYear: this.fromYear,
      toYear: this.toYear
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(CompetencyDictionaryPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  addNewCompetency() {
    if (this.selectedTypeTabName == 'Competency Master') {
      this.selectedUserForKPISearch = this.loggedInUserId;
    }
    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.data = {
      operation: 'Add',
      selectedTab: this.selectedTypeTabName,
      selectedUserID: this.selectedUserForKPISearch,
      fromYear: this.fromYear,
      toYear: this.toYear,
      selectedYear: this.selectedYearForCompetency
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(CompetencyAddNewComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.getAllCompetencyList();
    });
  }


  // *****************Get  competeny year***********


  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = [];
      
      data?.data?.yearRanges?.forEach((ele: any) => {
        var test = ele.split('_');
        let obj = {
          year: test[0] + '-' + test[1]
        }
        this.pmsYears.push(obj);
      });
      this.pmsYears?.forEach((ele: any) => {
        const currentYear = new Date().getFullYear();
        let yearValue = '';
        if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
          yearValue = `${currentYear}-${currentYear}`;


        } else {
          yearValue = `${currentYear}-${currentYear + 1}`;

        }
        
        if (ele?.year == yearValue) {
          this.selectedYearForCompetency = ele?.year;
          this.selectedYearForGraphOneHRAdmin = ele?.year
          this.selectedYearForGraphTwoHRAdmin = ele?.year
          this.selectedYearForGraphFifthHRAdmin = ele?.year
          this.selectedYearForGraphSix = ele?.year
          this.selectedYearForGraphNineHRAdmin = ele?.year
          this.selectedYearForGraphTenHRAdmin = ele?.year
          var test = ele?.year?.split('-');
          this.fromYear = test[0];
          this.toYear = test[1];
        }
      });
      //     this.getMonths(this.fromYear, this.toYear);
      this.getEmployeeUnderManager()
      this.getCompetencySetup();
      this.getAllFunctionsByYearRangeReport();
      if (this.selectedTypeTabName === 'My Competency') {
        this.getAllEmployeesUnderManagerView();
      } else if (this.selectedTypeTabName === 'Competency Master') {
        this.getAllCompetencyList();
      }
      else if (this.selectedTypeTabName === 'Team Competency') {
        this.getCompetencyByManagerTeamList();
      }
      this.getDepartmentsByCompany();
      if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
        || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
          this.getManagerListDashboard();
      }
      this.getGlobalSummary()
    })
  }

  getPmsYears() {
    // const request = {
    //   "companyId": this.loggedInUserCompanyID,
    //   "search": ""
    // }
    // this.httpService.callPostService(this.config.getPmsYears, request).subscribe((data: any) => {
    this.getpmsyearlist();

    // })
  }
  chnageSelectYear() {
    this.fromDate = null;
    this.toDate = null
    var year = this.selectedYearForCompetency?.split('-');
    if (year?.length != 0) {
      this.fromYear = year[0];
      this.toYear = year[1];
    }
    // sessionStorage.setItem('selectedYearForCompetency', this.selectedYearForCompetency);
    this.getMonths(this.fromYear, this.toYear)

  }
  getMonthsByFiscalandReviewCycleForReport: any[] = []
  getMonths(fromYear: any, toYear: any) {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: fromYear,
      toYear: toYear
    }
    this.httpService.callPostService(this.config.getMonths, request).subscribe((data: any) => {
      this.selectedReviewCycle = [];
      this.getMonthsByFiscalandReviewCycleForReport = []
      if (data?.data != null) {
        this.getMonthsByFiscalandReviewCycle = data.data?.months;
        data.data?.months?.forEach((ele: any) => {
          let obj = {
            id: ele,
            name: this.sharedService.transform(ele)
          }
          this.getMonthsByFiscalandReviewCycleForReport.push(obj)
        });
        this.selectedYearReviewCycle = data.data?.reviewCycle;
        const currentMonthIndex = new Date().getMonth(); // getMonth returns 0 for January, 11 for December
        let selectedIndex = 0;
        const today = new Date();
        const month = today.toLocaleString('default', { month: 'long' });

        if (this.selectedYearReviewCycle == 'Monthly') {
          this.getMonthsByFiscalandReviewCycle.forEach((ele: any) => {
            var checkMonth = ele?.split('-');
            if (month == checkMonth[0]) {
              this.fromDate = ele;
              this.toDate = ele;
              this.selectedReviewCycle.push({ id: ele, name: this.sharedService.transform(ele) });
            }
          });
        }

        if (this.selectedYearReviewCycle == 'Quarterly' || this.selectedYearReviewCycle == 'Semi_Annually'
          || this.selectedYearReviewCycle == 'Annually'
        ) {
          for (let range of this.getMonthsByFiscalandReviewCycle) {
            const [start, end] = range?.split('-');
            const startMonthIndex = this.getMonthIndex(start);
            const endMonthIndex = this.getMonthIndex(end);

            if (
              (currentMonthIndex >= startMonthIndex && currentMonthIndex <= endMonthIndex) ||
              (startMonthIndex > endMonthIndex && (currentMonthIndex >= startMonthIndex || currentMonthIndex <= endMonthIndex))
            ) {
              this.fromDate = range;
              this.toDate = range;
              this.selectedReviewCycle.push({ id: range, name: this.sharedService.transform(range) });
            }
          }
        }
        // this.getColumnVisibility();
        // this.getKPIsByDateRange();
      } else {
        this.getMonthsByFiscalandReviewCycle = []
        this.kpiDataListByUser = [];
        this.getAllkpiIDsList = [];
        this.totalPagesOfKpi = 0;
        this.totalKpis = 0;
        this.currentPageNumberOfKpis = 1;
        this.goalApprovalStatus = false;
        this.goalReviewStatus = false;
        // this.isKPIInPendingState = false;
        this.isAllReviewStatusNotApproved = false;
        this.allReviewAreApproved = false;
        this.totalWeightage = 0;
        this.totalKpiScore = 0;
      }
    })
  }
  getMonthName(monthIndex: number): string {
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return months[monthIndex];
  }

  getMonthIndex(monthName: string): number {
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return months.findIndex(month => month.toLowerCase() === monthName.toLowerCase());
  }
  getDepartmentList() {
    this.httpService.callGetService(this.config.getDepartmentList + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.deptListOfCompany = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.deptListOfCompany.push(obj);
      });
      this.deptListOfCompany = this.deptListOfCompany.sort((a: any, b: any) => a.name.localeCompare(b.name));
    })
  }
  getEmployeeMonthDataScorecard(employee: any, month: string) {
    return employee?.goals?.find((d: { month: string; }) => d.month === month) || { wt: 0, kpiScore: 0 };
  }
  getEmployeeMonthDataAllMonthYtd(employee: any, month: string) {
    return employee?.response?.find((d: { month: string; }) => d.month === month) || { wt: 0, kpiScore: 0 };
  }
  getReviewComplianceReportMonthData(employee: any, month: string) {
    return employee?.kpiuserdata?.find((d: { month: string; }) => d.month === month) || { goalReviewStatus: 0 };
  }
  getEmployeeMonthDataAllKpiwiseYtd(employee: any, month: string) {
    return employee?.monthlyData?.find((d: { month: string; }) => d.month === month) || { wt: 0, kpiScore: 0 };
  }

  // getBandFunctionList() {
  //   this.httpService.callGetService(this.config.getCompetencyFunctionAndBandList + this.loggedInUserCompanyID)
  //     .subscribe((data: any) => {
  //       const competencyFunctionAndBandList = data?.data;
  //       this.uniqueFunctions = competencyFunctionAndBandList?.uniqueFunctions || [];
  //       this.uniqueBands = competencyFunctionAndBandList?.uniqueBands || [];
  //     });
  // }


  onFunctionSelectionChange(event: any) {
    this.selectedFunction = event.value;
  }

  onBandSelectionChange(event: any) {
    this.selectedBands = event.value;
    this.errMsgDuplicateDeptandBand = null;
  }

  getEmployeeUnderManager() {
    
    this.httpService.callGetService(this.config.competencyEmployeeUnderManager + this.loggedInUserId + "/" + this.selectedYearForCompetency)
      .subscribe((data: any) => {
        
        this.employeelistUnderManager = (data?.data || []).map((employee: any) => ({
          id: employee.id,
          fullName: `${employee.firstName} ${employee.lastName}`.trim()
        }));
        this.employeelistUnderManager = this.employeelistUnderManager?.sort((a: { fullName: any; }, b: { fullName: any; }) => a.fullName.localeCompare(b.fullName));
        if (this.employeelistUnderManager.length != 0) {
          this.selectedEmployeeId = this.employeelistUnderManager[0].id;
          this.selectedEmployeeDashboardId = this.employeelistUnderManager[0].id;
          if(this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD'){
            this.selectedEmployeeDashboardId = this.loggedInUserId;
          }
          this.getEmployeeScoreAndRating();
          this.getGlobalSummary();
          this.getWeightageWiseCompentenciesGraphs();
          this.getCompetencyTopBottomScore();
          this.getCompetencyNamesWiseYearOnScore();
          if(this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
            || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD'){
              this.getCompetencyNameForEmployeeTableTeamGraph();
          }else{
            this.getListOfEmployeeManager();
          }
          this.getCompetencyTrend();
          this.getCompetencyWiseEmployeeGraph();
          this.getComparisonEmployeeWiseList();
          this.getCompetencyYearonYear();
          this.getCompetencyYearWiseOnYearScore();
        }else{
          if(this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD'){
            this.selectedEmployeeDashboardId = this.loggedInUserId;
          }
        }
      });
  }

  onEmployeeSelectionChange(event: any) {

    if (event && typeof event === 'object') {
      this.selectedEmployeeId = event.id || event;
    } else {
    }
    this.getCompetencyByManagerTeamList()

  }


  getCompetencyByManagerTeamList() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      employeeId: this.selectedEmployeeId,
      managerCode: this.loggedInUserEmpCode,
      yearRange: this.selectedYearForCompetency,
      searchString: this.searchString
    };
    this.loader.simpleLoaderWithDuration();
    this.httpService.callPostService(this.config.getCompetencyByManager + '?page=' + this.page + '&size=' + this.selectedSizeOfPMS, request).subscribe(
      (response: any) => {
        
        if (response?.status) {
          this.allowedToEditTeamCompetency = response.data?.allowedToEdit;
          this.competencyListManagerView = response.data.data.map((employee: any) => ({
            ...employee,
            evaluatedByManager: employee.evaluatedBy,
            evaluatedAtManager: employee.evaluatedAt
          }));
          this.totalItems = response.data.total;
          this.totalPages = response.data.totalPages;
          this.currentPage = response.data.currentPageNumber;
        } else {
          this.competencyListManagerView = [];
          this.totalItems = 0;
          this.totalPages = 0;
          this.currentPage = 0;
        }
        this.loader.dismissLoader();
      },
      error => {
        this.loader.dismissLoader();
      }
    );
  }

  isEditable(column: string): boolean {
    return this.editableColumns.has(column);
  }


  updateAchieved(itemIndex: number, compIndex: number, value: number) {
    if (value < 0) {
      value = 0;
    } else if (value > 100) {
      value = 100;
    }
    const competency = this.competencyListManagerView[itemIndex].competencyMasterlist[compIndex];
    competency.achived = value;
    this.calculateManagerTotals();
  }

  myCompetencyEvaluatedAt:any
  getAllEmployeesUnderManagerView() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      employeeId: this.loggedInUserId,
      managerCode: this.loggedInUserEmpCode,
      yearRange: this.selectedYearForCompetency,
      searchString: this.searchString,
    };
    this.httpService.callPostService(this.config.competencyGetAllEmployee + '?page=' + this.page + '&size=' + this.selectedSizeOfPMS, request).subscribe(
      (response: any) => {
        
        if (response?.status && response.data.data.length > 0) {
          this.allowedToEditManagerMycompetency = response.data.allowedToEdit;
          this.competencyemployee = response.data.data.map((employee: any) => ({
            band: employee.band,
            functionName: employee.functionName,
            managerComment: employee.managerComment,
            employeeComment: employee.employeeComment,
            companyid: employee.companyId,
            employeeCompetencyId: employee.competencyId,
            competencyEvaluatedId: employee.id,
            evaluatedRating: employee.evaluatedRating,
            competencyMasterlist: employee.competencyMasterlist.map((comp: any) => ({
              competencyName: comp.competencyName,
              competencyDefinition: comp.competencyDefination,
              weightageNo: comp.weightageNo,
              achived: comp.achived,
              evaluatedRating: employee.evaluatedRating,
            }))
          }));
          this.myCompetencyEvaluatedAt = response?.data?.evaluatedAt;
          this.totalItems = response.data.total;
          this.totalPages = response.data.totalPages;
          this.currentPage = response.data.currentPageNumber;

          this.calculateScoresEmployeeList();
          this.calculateEmployeeTotalWeight();
        } else {
          this.competencyemployee = [];
          this.totalItems = 0;
          this.totalPages = 0;
          this.currentPage = 0;
        }
      },
      (error) => {
        this.competencyemployee = [];
        this.totalItems = 0;
        this.totalPages = 0;
        this.currentPage = 0;
      }
    );
  }






  calculateEmployeeTotalWeight() {
    this.employeetotalweight = this.competencyemployee.map((employee: any) => {
      return employee.competencyMasterlist?.reduce((total: number, competency: any) => {
        return total + (competency.weightageNo || 0);
      }, 0);
    });
  }


  editItem(id: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.data = {
      operation: 'Edit',
      editId: id
    };
    dialogConfig.panelClass = 'custom-dialog-container';

    const dialogRef = this.dialog.open(CompetencyAddNewComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      this.getAllCompetencyList();
    });
  }



  onBlur(comp: any, item: any): void {
    
    const payload = {
      yearRange: this.selectedYearForCompetency,
      band: item.band,
      companyId: item.companyId,
      competencyId: item.competencyId,
      employeeComment: item.employeeComment || null,
      employeeId: this.selectedEmployeeId,
      evaluatedSubList: item.competencyMasterlist.map((comp: any) => ({
        achived: comp.achived,
        id: comp.id,
        subCompId: comp.sumCompId
      })),
      functionName: item.functionName,
      id: item.id || null,
      managerCode: this.loggedInUserEmpCode,
      managerComment: item.managerComment
    };


    // Call the service to save the data or just the manager's comment
    this.httpService.callPostService(this.config.competencyEvaluateByManagr, payload)
      .subscribe(
        (data: any) => {
          if (data?.status) {
            this.getCompetencyByManagerTeamList();
          } else {
          }
        },
        (error: any) => {
        }
      );
  }




  editManagerComment(index: number) {
    this.editedIndex = index;
  }

  updateManagerComment(item: any, index: number) {

  }

  editEmployeeComment(index: number): void {
    this.editedEmployeeCommentIndex = index;
  }

  updateEmployeeComment(employee: any, competency: any): void {
    const payload = {
      comment: employee.employeeComment || '',
      companyId: employee.companyid,
      competencyId: employee.employeeCompetencyId,
      evaluatedComptId: employee.competencyEvaluatedId
    };
    this.httpService.callPostService(this.config.autoSaveCompetencyEmployee, payload)
      .subscribe(
        (data: any) => {
          if (data?.success) {
          } else {
          }
        },
        (error: any) => {
        }
      );
  }

  calculateScoresEmployeeList(): void {
    this.competencyemployee.forEach((employee: { competencyMasterlist: any[]; totalScore: number; }) => {
      let totalScore = 0;
      employee.competencyMasterlist.forEach((competency) => {
        if (competency.weightageNo != null && competency.achived != null) {
          competency.score = Math.round((competency.weightageNo * competency.achived) / 100); // Rounds to the nearest integer
          totalScore += competency.score;
        } else {
          competency.score = null;
        }
      });
      employee.totalScore = totalScore;
    });
  }


  onSearch(data: string) {
    if (data == '') {
      this.searchString = null;
    } else {
      this.searchString = data;
    }
    if (this.selectedTypeTabName === 'My Competency') {
      this.getAllEmployeesUnderManagerView();
    } else if (this.selectedTypeTabName === 'Competency Master') {
      this.getAllCompetencyList();
    }
    else if (this.selectedTypeTabName === 'Team Competency') {
      this.getCompetencyByManagerTeamList();
    }
  }


  get startItem(): number {
    return (this.currentPage * this.pageSize) + 1;
  }

  get endItem(): number {
    return Math.min((this.currentPage + 1) * this.pageSize, this.totalItems);
  }

  changePage(pageNumber: number) {
    if (pageNumber >= 0 && pageNumber < this.totalPages) {
      this.currentPage = pageNumber;
      // this.getAllEmployees(this.currentPage, this.pageSize);
    }
  }

  updatePagination() {
    this.startItemhr = this.currentPage * this.itemsPerPage + 1;
    this.endItemhr = Math.min((this.currentPage + 1) * this.itemsPerPage, this.totalItems);
  }

  changePageHrAdmin(pageIndex: number) {
    if (pageIndex >= 0 && pageIndex < this.totalPages) {
      this.currentPage = pageIndex;
      this.getAllCompetencyList();
    }
  }
  errMsgForTotal:any=null;
  indexOfErrMsgWtTotal:any=null;
  indexOfErrMsgDuplicateNameandDef:any=null
  onWeightageChange(item: any,index:any) {
    const totalWeight = this.getTotalWeight(item);
    
    if (totalWeight === 100) {
      // Call the save method when total weight equals 100
      this.errMsgForTotal = null;
      this.indexOfErrMsgWtTotal = null;
      this.hradmincompetencyeditandsave(item,index);
    } else {
      this.indexOfErrMsgWtTotal = index;
      this.errMsgForTotal = 'Total WT should be 100';
      // Optionally, you could add some logic here to show a message or prevent saving if total is not 100
    }
  }
  errMsgDuplicateNameandDef:any=null;
  uniqueCompetencyValidator(item: any,index:any) {
    // return (formArray: AbstractControl): { [key: string]: boolean } | null => {
    //   const competencies = formArray.value;
    
      const namesAndDefinitions = new Set<string>();
      this.errMsgDuplicateNameandDef = null;
      this.indexOfErrMsgDuplicateNameandDef = null;
      for (const competency of item?.competencyMasterlist) {
        const name = competency.competencyName?.trim();
        const definition = competency.competencyDefination?.trim();
        
        if (name && definition) {
          const key = `${name}-${definition}`;
          
          if (namesAndDefinitions.has(key)) {
            this.indexOfErrMsgDuplicateNameandDef = index;
            this.errMsgDuplicateNameandDef ="Duplicate Competency Name and Definition combination detected."
          }
          
          namesAndDefinitions.add(key);
        }
      }
    // };
  }
  hradmincompetencyeditandsave(item: any,index:any): void {
    
    // if(this.errMsgDuplicateNameandDef!=null){
    //   return;
    // }
    const competencyMasterlist = item.competencyMasterlist || [];
    const payload = {
      id: item.id,
      band: item.band,
      companyId: item.companyId,
      functionName: item.functionName,
      yearRange: this.selectedYearForCompetency,
      competencyMasterlist: competencyMasterlist.map((comp: any) => ({
        id: comp.id || null,
        competencyDefination: comp.competencyDefination || '',
        competencyName: comp.competencyName || '',
        weightageNo: comp.weightageNo || 0
      }))
    };
    for(let i= 0;i<payload.competencyMasterlist.length;i++){
      if(payload.competencyMasterlist[i].competencyName=='' 
       || payload.competencyMasterlist[i].competencyDefination==''){
        this.indexOfErrMsgDuplicateNameandDef = index;
        this.errMsgDuplicateNameandDef ="Competency Name and Definition can not be empty."
        return;
      }
    }
    this.httpService.callPostService(this.config.addCompetencyMaster, payload)
      .subscribe(
        (response: any) => {
          this.indexOfErrMsgDuplicateNameandDef = null;
          this.errMsgDuplicateNameandDef =null;
        },
        (error: any) => {
        }
      );
  }

  onBandSelectionChangeBand(event: MatSelectChange, competency: any) {
    competency.band = event.value;
    // this.hradmincompetencyeditandsave(competency, 'band');
  }

  // Handle function selection change
  onFunctionSelectionChangeFunction(event: MatSelectChange, competency: any) {
    competency.functionName = event.value;
    // this.hradmincompetencyeditandsave(competency, 'functionName');
  }



  //the reports apis here

  clearFilter() {
    this.bands = [];
    this.selectedBands = [];
    this.selectedEmployees = [];
    this.selectedEmployeeIds = [];
    this.employeeList = [];
    this.selectedFunctionsForHrAdmin = [];
    this.reportDataList = []
  }

  clearFilterManager() {
    this.MbandList = [];
    this.selectedBandForManager = [];
    this.selectedEmployeesManager = [];
    this.selectedEmployeeIdsManager = [];
    this.employeeList = [];
    this.selectedManagerFunctions = [];
    this.reportDataList = [];
    this.selectedBands = [];
    this.bandListHrAdmin = [];
  }
  clearFilterEmployee() {

  }
  getAllFunctionsByYearRangeReport() {
    this.employeeList = [];
    this.selectedEmployees = []
    this.dropdownData = [];
    this.bands = [];
    this.selectedBands = []
    this.selectedFunctionsForHrAdmin = [];
    const request = {
      companyId: this.loggedInUserCompanyID,
      managerCode: null,
      yearRange: this.selectedYearForCompetency,
      gradeOrBand: this.setupGradeBrand
    };

    this.httpService.callPostService(this.config.getAllFunctionsByYearRange, request).subscribe(
      (response: any) => {
        if (response && response?.status) {
          this.dropdownData = response?.data;
        } else {
        }
      },
      (error) => {
      }
    );
  }


  onItemSelect(item: any) {
    this.selectedBands = [];
    this.selectedEmployees = [];
    this.employeeList = [];
    if (this.setupGradeBrand == 'Band') {
      this.getBandsByDepartment()
    } else {
      this.getGradesByDepartment()
    }
    // this.getAllBandsByHrAdmin();
  }

  onItemDeselect(item: any) {
    this.selectedBands = [];
    this.selectedEmployees = [];
    this.employeeList = [];
    if (this.setupGradeBrand == 'Band') {
      this.getBandsByDepartment()
    } else {
      this.getGradesByDepartment()
    }
  }

  onSelectAll(items: any) {
    this.selectedBands = [];
    this.selectedFunctionsForHrAdmin = items;
    this.selectedEmployees = [];
    this.employeeList = [];
    if (this.setupGradeBrand == 'Band') {
      this.getBandsByDepartment()
    } else {
      this.getGradesByDepartment()
    }
  }

  logSelectedItems() {
    this.getAllBandsByHrAdmin();
  }


  onDeselectAll(items: any) {
    this.bands = [];
    this.selectedBands = [];
    this.selectedEmployees = [];
    this.selectedEmployeeIds = [];
    this.employeeList = [];
  }



  getAllBandsByHrAdmin() {
    this.bands = [];
    const payload = {
      companyId: this.loggedInUserCompanyID,
      managerCode: null,
      function: this.selectedFunctionsForHrAdmin.map((ele: { id: any; }) => ele.id),
      yearRange: this.selectedYearForCompetency,
      gradeOrBand: this.setupGradeBrand
    };

    this.httpService.callPostService(this.config.getAllBandsByHrAdmin, payload).subscribe(
      (response: any) => {
        if (response && response.status) {
          this.bands = response.data;
        } else {
        }
      },
      (error) => {
      }
    );
  }

  onBandSelect(event: any) {
    this.selectedEmployees = [];
    if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
      this.getAllEmployeeListByManager();
    }
    if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
      || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
      this.getAllEmployeeListByHrAdmin();
    }
  }

  onBandDeSelect(event: any) {
    this.selectedBands = [];
    this.selectedEmployees = [];
    if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
      this.getAllEmployeeListByManager();
    }
    if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
      || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
      this.getAllEmployeeListByHrAdmin();
    }
  }

  onBandSelectAll(event: any) {
    this.selectedEmployees = [];
    if (event && event.length > 0) {
      this.selectedBands = [...event]; // Select all bands
    } else {
    }
    if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
      this.getAllEmployeeListByManager();
    }
    if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
      || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
      this.getAllEmployeeListByHrAdmin();
    }
  }

  onBandDeSelectAll(event: any) {
    this.selectedEmployees = [];
    this.selectedEmployeeIds = [];
    this.employeeList = []; // Clear employee list
    this.cd.detectChanges(); // Manually trigger change detection
  }



  onBandChange(event: any) {
    this.getAllEmployeeListByHrAdmin();

  }
  getAllEmployeeListByHrAdmin() {
    this.selectedEmployees = [];
    this.selectedEmployeeIds = [];
    const request = {
      companyId: this.loggedInUserCompanyID,
      managerCode: null,
      function: this.selectedFunctionsForHrAdmin.map((ele: { id: any; }) => ele.id),
      band: this.selectedBands.map((ele: { id: any; }) => ele.id),
      yearRange: this.selectedYearForCompetency,
      gradeOrBand: this.setupGradeBrand
    };

    this.httpService.callPostService(this.config.getAllEmployeeListByHrAdmin, request).subscribe(
      (response: any) => {
        if (response && response.status) {
          this.employeeList = response.data.map((employee: { employeeId: any; firstName: any; lastName: any; id: any }) => ({
            id: employee.id,
            itemName: `${employee.firstName} ${employee.lastName}`
          }));
          this.employeeList = this.employeeList.sort((a: { itemName: any; }, b: { itemName: any; }) => a.itemName.localeCompare(b.itemName));
        } else {
          this.employeeList = [];
        }
      },
      (error) => {
        this.employeeList = [];
      }
    );
  }



  onEmployeeSelect(event: any) {
    if (Array.isArray(event)) {
      this.selectedEmployees = event;
    } else {
      this.selectedEmployees.push(event);
    }
    this.submitData();
    this.updateSelectedEmployeeIds();
  }


  onEmployeeDeselect(event: any) {
    this.selectedEmployees = this.selectedEmployees.filter((emp: { id: any; }) => emp.id !== event.id);
    this.submitData();
    this.updateSelectedEmployeeIds();
  }

  onSelectAllEmployees(event: any) {
    this.selectedEmployees = Array.isArray(event) ? event : [];
    this.submitData();
    this.updateSelectedEmployeeIds();
  }

  onDeselectAllEmployees(event: any) {
    this.selectedEmployees = [];
    this.selectedEmployeeIds = [];
    this.reportDataList = [];
  }


  private updateSelectedEmployeeIds() {
    if (Array.isArray(this.selectedEmployees)) {
      this.selectedEmployeeIds = this.selectedEmployees.map(item => Number(item.id));
    } else {
      this.selectedEmployeeIds = [];
    }
  }



  submitEmployeeReportData() {
    this.getAllEmployeesUnderManagerView()
    const request = {
      companyId: this.loggedInUserCompanyID,
      employeeId: this.loggedInUserId,
      searchString: this.searchStringReport,
      yearRange: this.selectedYearForCompetency,
    };

    if (this.loggedInUserRole === 'Employee') {
      // Optionally modify the request object or perform specific actions for 'Employee' role

    }

    // Make the HTTP POST request
    this.httpService.callPostService(this.config.getEmployeeReport+ '?page=' + this.page + '&size=' + this.selectedSizeOfReport, request).subscribe(
      (response: any) => {
        if (response?.data?.data) {
          this.totalItems = response.data.total;
          this.totalPages = response.data.totalPages;
          this.currentPage = response.data.currentPageNumber;
          this.reportDataList = response.data?.data;
        } else {
          // If no data is returned, clear the report data list
          this.reportDataList = [];
        }
      },
      (error: any) => {
        // Handle errors gracefully
        // Clear the report data list on error
        this.reportDataList = [];
      }
    );
  }


  // clearFilter() {
  //   // this.selectedYearForCompetency = null;
  //   // this.reportDataList = [];
  // }



  //manager dropdown 
  getAllManagerBands() {
    const payload = {
      companyId: this.loggedInUserCompanyID,
      managerCode: this.loggedInUserEmpCode,
      function: this.selectedFunctionsForHrAdmin.map((ele: { id: any; }) => ele.id),
      yearRange: this.selectedYearForCompetency,
      gradeOrBand: this.setupGradeBrand
    };

    this.httpService.callPostService(this.config.getAllBandByYearRangeForManager, payload).subscribe(
      (ManagerBands: any) => {
        this.bands = ManagerBands.data;
      },
      (error) => {
      }
    );
  }


  submitData() {
      const request = {
        companyId: this.loggedInUserCompanyID,
        employeeId: this.selectedEmployees.map((ele: any) => ele.id),
        managerCode: null,
        searchString: this.searchStringReport,
        yearRange: this.selectedYearForCompetency,
        gradeOrBand: this.setupGradeBrand
      };
      if (this.loggedInUserRole === 'Manager' || this.loggedInUserRole === 'HOD') {
        request.managerCode = this.loggedInUserEmpCode;
      } else if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
        || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
        request.managerCode = null;
      }

      this.httpService.callPostService(this.config.gerReportHrAdmin+ '?page=' + this.page + '&size=' + this.selectedSizeOfReport, request).subscribe(
        (response: any) => {
          this.totalItems = response.data.total;
          this.totalPages = response.data.totalPages;
          this.currentPage = response.data.currentPageNumber;
          this.processReportData(response.data);
        },
        (error) => {
        }
      );
  }
  //report downloads APIS
  downloadReportHrAdmin() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      employeeId: this.selectedEmployeeIds,
      managerCode: null,
      searchString: null,
      yearRange: this.selectedYearForCompetency,
      gradeOrBand: this.setupGradeBrand
    };
    this.httpService.callPostService(this.config.getExcelReportHrAdmin, request).subscribe(
      (data: any) => {
        if(data?.data!=null){
          var fileName = data?.data?.split(environment.downloadURL)
          saveAs(data?.data, fileName[1]); 
        }
      },
      (error) => {
      }
    );
  }

  downloadReportManagerPdf() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      employeeId: this.selectedEmployeeIdsManager,
      managerCode: this.loggedInUserEmpCode,
      searchString: null,
      yearRange: this.selectedYearForCompetency,
      gradeOrBand: this.setupGradeBrand
    };
    this.httpService.callPostService(this.config.getExcelReportManagerpdf, request).subscribe(
      (data: any) => {
        if(data?.data!=null){
          var fileName = data?.data?.split(environment.downloadURL)
          saveAs(data?.data, fileName[1]); 
        }
      },
      (error) => {
      }
    );
  }


  downloadReportEmployeePdf() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      employeeId: this.loggedInUserId,
      searchString: null,
      yearRange: this.selectedYearForCompetency,

    };
    this.httpService.callPostService(this.config.getExcelReportEmployeepdf, request).subscribe(
      (data: any) => {
        if(data?.data!=null){
          var fileName = data?.data?.split(environment.downloadURL)
          saveAs(data?.data, fileName[1]); 
        }
      },
      (error) => {
      }
    );
  }


  downloadReportHrAdminExcel() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      employeeId: this.selectedEmployeeIds,
      managerCode: null,
      searchString: null,
      yearRange: this.selectedYearForCompetency,
      gradeOrBand: this.setupGradeBrand
    };
    this.httpService.callPostService(this.config.getExcelReportHrAdminExcel, request).subscribe(
      (data: any) => {
        if(data?.data!=null){
          var fileName = data?.data?.split(environment.downloadURL)
          saveAs(data?.data, fileName[1]); 
        }
      },
      (error) => {
      }
    );
  }



  downloadReportManagerExcel() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      employeeId: this.selectedEmployeeIdsManager,
      managerCode: this.loggedInUserEmpCode,
      searchString: null,
      yearRange: this.selectedYearForCompetency,
      gradeOrBand: this.setupGradeBrand
    };
    this.httpService.callPostService(this.config.getExcelReportManagerExcel, request).subscribe(
      (data: any) => {
        if(data?.data!=null){
          var fileName = data?.data?.split(environment.downloadURL)
          saveAs(data?.data, fileName[1]); 
        }
      },
      (error) => {
      }
    );
  }

  downloadReportEmployeeExcel() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      employeeId: this.loggedInUserId,
      searchString: null,
      yearRange: this.selectedYearForCompetency,
    };
    this.httpService.callPostService(this.config.getExcelReportEmployeeExcel, request).subscribe(
      (data: any) => {
        if(data?.data!=null){
          var fileName = data?.data?.split(environment.downloadURL)
          saveAs(data?.data, fileName[1]); 
        }
      },
      (error) => {
      }
    );
  }







  processReportData(reportData: any) {
    if (reportData && reportData.data) {
      this.reportDataList = reportData.data;
    } else {
      // Handle the case where reportData is null or does not contain data
      this.reportDataList = []; // or any default value
    }
  }
  getEvaluatedRating(reportItem: any): number | null {
    return reportItem.evaluatedRating; // Adjust according to the actual structure
  }

  calculateScore(weightageNo: number, achieved: number): number {
    if (weightageNo == null || achieved == null) {
      return 0;
    }
    return (weightageNo * achieved) / 100;
  }

  // Calculate the total weightage for each competency group
  getTotalWeightForCompetency(competencyList: any[]): number {
    return competencyList?.reduce((total, competency) => total + (competency.weightageNo || 0), 0);
  }

  // Calculate the total score for each competency group
  getTotalScoreForCompetency(competencyList: any[]): number {
    return competencyList?.reduce((total, competency) => total + this.calculateScore(competency.weightageNo || 0, competency.achived || 0), 0);
  }


  getFunctionListManager() {
    this.ManagerDropdownDataReportManager = []
    this.managerFunctionsList = [];
    this.selectedManagerFunctions = [];
    this.managerBandList = [];
    this.selectedBandForManager = [];
    const request = {
      companyId: this.loggedInUserCompanyID,
      managerCode: this.loggedInUserEmpCode,
      yearRange: this.selectedYearForCompetency,
      gradeOrBand: this.setupGradeBrand
    };

    this.httpService.callPostService(this.config.getAllFunctionByYearRangeForManager, request).subscribe(
      (response: any) => {
        this.managerFunctionsList = response.data;
        // this.ManagerDropdownDataReportManager = response.data;
        this.managerFunctionsList = [];
        response?.data?.forEach((ele: any) => {
          let obj = {
            id: ele,
            itemName: ele,
          }
          this.managerFunctionsList.push(obj);
        });
        this.managerFunctionsList = this.managerFunctionsList.sort((a: { itemName: any; }, b: { itemName: any; }) => a.itemName.localeCompare(b.itemName));
      },
      (error) => {
      }
    );
  }

  onManagerItemSelect(item: any) {
    this.selectedManagerFunctions.push(item);
    this.getBandListManager()
  }

  onManagerItemDeselect(item: any) {
    this.MbandList = [];
    this.selectedBandForManager = [];
    this.selectedEmployeesManager = [];
    this.employeeList = []
    this.ManagerEmployeeIds = this.selectedManagerFunctions.filter(f => f.id !== item.id);
  }

  onManagerSelectAll(items: any) {
    if (Array.isArray(items)) {
      this.ManagerEmployeeIds = items.map((item: any) => item.id); // Adjust if you need a different property
      this.getBandListManager(); // Fetch or process the data as needed
    } else {
    }
  }


  onManagerDeselectAll(items: any) {
    this.MbandList = [];
    this.selectedBandForManager = [];
    this.selectedEmployeesManager = [];
    this.selectedBands =[];
    if (items && Array.isArray(items)) {
      const deselectedNames = items.map((item: any) => item ? item.name : 'undefined');
    } else {
    }
  }

  getBandListManager() {
    this.MbandList = []
    const request = {
      companyId: this.loggedInUserCompanyID,
      managerCode: this.loggedInUserEmpCode,
      yearRange: this.selectedYearForCompetency,
      function: this.getListOfDepartmentsOfComp.map((ele: any) => ele.id),
      gradeOrBand: this.setupGradeBrand
    };
    this.httpService.callPostService(this.config.getAllBandByYearRangeForManager, request).subscribe(
      (response: any) => {
        this.managerBandList = response.data;
        this.MbandList = response.data;
        this.bandListHrAdmin = response.data.map((ele: any) => ({
          id: ele,
          itemName: ele
        }));
        this.bandListHrAdmin = this.bandListHrAdmin.sort((a: { itemName: any; }, b: { itemName: any; }) => a.itemName.localeCompare(b.itemName));
      },
      (error) => {
      }
    );
  }

  onBandManagerSelected(event: any) {

    if (Array.isArray(event)) {
      this.ManagerEmployeeIds = event.map((item: any) => item.id);
    } else if (event && event.id) {
      this.ManagerEmployeeIds = [event.id];
    } else {
    }

    this.getAllEmployeeListByManager();
  }

  onManagerBandSelected(event: any) {
    this.getAllEmployeeListByManager();
  }

  onManagerBandDeSelected(event: any) {
    this.employeeList = [];
    this.selectedEmployeesManager = [];
  }
  onManagerSelectAllBands(items: any) {
    this.selectedBands = items;
    this.getAllEmployeeListByManager()
  }

  onManagerDeSelectAllBands(event: any) {
    this.employeeList = [];
    this.selectedEmployeesManager = [];
    this.ManagerEmployeeIds = [];
  }








  CronJob() {
    this.httpService.callGetService(this.config.setupTrigger).subscribe(
      (response: any) => {

      })
  }

  calculateManagerTotals() {
    this.totalWt = 0;
    this.totalScore = 0;

    this.competencyListManagerView.forEach((item: { competencyMasterlist: any[]; }) => {
      item.competencyMasterlist.forEach((comp: { weightageNo: any; achived: any; }) => {
        this.totalWt += comp.weightageNo || 0;
        this.totalScore += (comp.weightageNo || 0) * (comp.achived || 0) / 100;
      });
    });
  }

  getTotalWeight(item: any): number {
    return item.competencyMasterlist?.reduce((acc: number, comp: any) =>
      acc + (comp.weightageNo || 0), 0);
  }

  getTotalScore(item: any): number {
    return item.competencyMasterlist?.reduce((acc: number, comp: any) =>
      acc + ((comp.weightageNo || 0) * (comp.achived || 0) / 100), 0);
  }


  getAllEmployeeListByManager() {
    
    this.employeeList = [];
    const request = {
      companyId: this.loggedInUserCompanyID,
      managerCode: this.loggedInUserEmpCode,
      function: this.getListOfDepartmentsOfComp.map((ele: any) => ele.id),
      band: this.selectedBands.map((ele: any) => ele.id),
      yearRange: this.selectedYearForCompetency,
      gradeOrBand: this.setupGradeBrand
    };

    this.httpService.callPostService(this.config.getAllEmployeesByManagerReports, request).subscribe(
      (response: any) => {
        if (response && response.data) {
          this.employeeList = response.data.map((employee: any) => ({
            id: employee.id,
            itemName: `${employee.firstName} ${employee.lastName}`
          }));
          this.employeeList = this.employeeList.sort((a: { itemName: any; }, b: { itemName: any; }) => a.itemName.localeCompare(b.itemName));
        }
      },
      (error) => {
      }
    );
  }



  onEmployeeSelectManager(event: any) {
    if (Array.isArray(event)) {
      const selectedIds = event.map((item: any) => item.id);
    } else {
    }
  }

  onManagerEmployeeListSelect(event: any) {

    if (event && event.id) {
      this.selectedEmployeeIdsManager.push(event.id);
    } else {
    }
  }

  onManagerEmployeeListDeselect(event: any) {

    if (event && event.id) {
      this.selectedEmployeeIdsManager = this.selectedEmployeeIdsManager.filter(
        (id) => id !== event.id
      );
    } else {
    }
  }

  onManagerSelectAllEmployees(event: any) {
    this.selectedEmployeeIdsManager = event.map((item: any) => item.id);
  }

  onManagerDeselectAllEmployees(event: any) {
    this.selectedEmployeeIdsManager = [];
  }



  submitManagerDataReport() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      employeeId: this.selectedEmployeeIdsManager,
      managerCode: this.loggedInUserEmpCode,
      searchString: this.searchStringReport,
      yearRange: this.selectedYearForCompetency,
      gradeOrBand: this.setupGradeBrand
    };
    if (this.loggedInUserRole === 'Manager' || this.loggedInUserRole === 'HOD') {
      request.managerCode = this.loggedInUserEmpCode;
    } else if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
      || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
      request.managerCode = null;
    }
    this.httpService.callPostService(this.config.getManagerReports+ '?page=' + this.page + '&size=' + this.selectedSizeOfReport, request).subscribe(
      (ManagerReport: any) => {
        this.totalItems = ManagerReport.data.total;
        this.totalPages = ManagerReport.data.totalPages;
        this.currentPage = ManagerReport.data.currentPageNumber;
        this.processReportData(ManagerReport.data);
      },
      (error) => {
      }
    );
  }


  //latest function and band api dependent

  getFunctionListHrAdmin() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      managerCode: null,
      yearRange: this.selectedYearForCompetency,
      gradeOrBand: this.setupGradeBrand
    };

    this.httpService.callPostService(this.config.GetHrAdminFunctionsByYear, request)
      .subscribe((response: any) => {
        if (response?.data && Array.isArray(response.data)) {
          this.functionsListHrAdminData = response.data;
        } else {
          this.functionsListHrAdminData = [];
        }
      });
  }

  indexOfErrMsgDuplicateDeptandBand:any = null;
  errMsgDuplicateDeptandBand:any=null;
  onFunctionChange(event: any,data:any,index:any) {
    
    this.functionsListHrAdminData = []
    this.functionsListHrAdminData.push(event);
    data.band = null;
    this.indexOfErrMsgDuplicateDeptandBand = index;
    this.errMsgDuplicateDeptandBand = 'Please select '+this.setupGradeBrand;
    this.getBandListHrAdmin();
  }

  getBandListHrAdmin() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      managerCode: null,
      yearRange: this.selectedYearForCompetency,
      function: this.functionsListHrAdminData,
      gradeOrBand: this.setupGradeBrand
    };

    this.httpService.callPostService(this.config.GetHrAdminBandByYear, request)
      .subscribe(
        (response: any) => {
          this.bandListHrAdmin = [];
          if (response?.status) {
            this.bandListHrAdmin = response.data || [];
          } else {
          }
        },
        (error: any) => {
        }
      );
  }

  onClickImportCompetency() {
    const selectedYear = this.selectedYearForCompetency;
    this.router.navigate(['/home/hrportal/importFiles', { module: 'competencyImport', year: selectedYear }]);
  }


  //Dshboard HrAdmin

  getManagerListDashboard() {
    
    this.httpService.callGetService(this.config.managerListDashboardDropdown + this.loggedInUserCompanyID + '/' + this.selectedYearForCompetency)
      .subscribe((response: any) => {
        
        if (response && response.status) {
          // Process the response to add a fullName property
          this.managerListDashboardHrAdmin = response.data.map((employee: any) => {
            return {
              ...employee,
              fullName: `${employee.firstName} ${employee.lastName}`
            };
          });
          this.managerListDashboardHrAdmin = this.managerListDashboardHrAdmin.sort((a: any, b: any) => a.fullName.localeCompare(b.fullName));
          if(this.managerListDashboardHrAdmin.length!=0){
            this.selectedManagerDashboardId=this.managerListDashboardHrAdmin[0].id;
            this.getEmployeeUnderManagerGraph();
          }else{
            this.selectedManagerDashboardId = null;
            this.selectedEmployeeDashboardId = null;
            this.employeelistUnderManagerGraphHrAdmin = [];
            this.getEmployeeScoreAndRating();
            this.getGlobalSummary();
            this.getWeightageWiseCompentenciesGraphs();
            this.getCompetencyTopBottomScore();
            this.getCompetencyNamesWiseYearOnScore();
            if(this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
              || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD'){
                this.getCompetencyNameForEmployeeTableTeamGraph();
            }else{
              this.getListOfEmployeeManager();
            }            
            this.getCompetencyTrend();
            this.getCompetencyWiseEmployeeGraph();
            this.getComparisonEmployeeWiseList();
            this.getCompetencyYearonYear();
            this.getCompetencyYearWiseOnYearScore();
          }
        }
      });
  }

  onManagerSelectedDashboardHrAdmin(selectedManagerDashboardHrAdmin: any) {
    
    this.selectedManagerDashboardId = selectedManagerDashboardHrAdmin.id;
    this.selectedEmployeeIdForScoreAndRating = selectedManagerDashboardHrAdmin.employeeId;
    this.getEmployeeUnderManagerGraph()
  }

  getEmployeeUnderManagerGraph() {
    
    this.httpService.callGetService(this.config.competencyEmployeeUnderManager + this.selectedManagerDashboardId + "/" + this.selectedYearForCompetency)
      .subscribe((data: any) => {
        this.employeelistUnderManagerGraphHrAdmin = (data?.data || []).map((employee: any) => ({
          id: employee.id,
          fullName: `${employee.firstName} ${employee.lastName}`.trim()
        }));
        this.employeelistUnderManagerGraphHrAdmin = this.employeelistUnderManagerGraphHrAdmin.sort((a: any, b: any) => a.fullName.localeCompare(b.fullName));
        if(this.employeelistUnderManagerGraphHrAdmin.length!=0){
          this.selectedEmployeeDashboardId=this.employeelistUnderManagerGraphHrAdmin[0].id;
        }else{
          this.selectedEmployeeDashboardId=null
        }
          this.getEmployeeScoreAndRating();
          this.getGlobalSummary();
          this.getWeightageWiseCompentenciesGraphs();
          this.getCompetencyTopBottomScore();
          this.getCompetencyNamesWiseYearOnScore();
          if(this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
            || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD'){
              this.getCompetencyNameForEmployeeTableTeamGraph();
          }else{
            this.getListOfEmployeeManager();
          }
          this.getCompetencyTrend();
          this.getCompetencyWiseEmployeeGraph();
          this.getComparisonEmployeeWiseList();
          this.getCompetencyYearonYear();
          this.getCompetencyYearWiseOnYearScore();
      });
  }

  getLoginUserGraphData() {
    this.getWeightageWiseCompentenciesGraphs();
    this.getCompetencyTopBottomScore();
    this.getCompetencyNamesWiseYearOnScore();
    this.getCompetencyTrend();
  }

  onEmployeeSelectionChangeUnderManagerGraph(selectedEmployeeDashboardForGraph: any) {
    this.selectedEmployeeDashboardId = selectedEmployeeDashboardForGraph.id;
    this.selectedEmployeeDashboardFullName = selectedEmployeeDashboardForGraph.fullName;
    this.getEmployeeScoreAndRating();
    this.getGlobalSummary();
    this.getWeightageWiseCompentenciesGraphs();
    this.getCompetencyTopBottomScore();
    this.getCompetencyNamesWiseYearOnScore();
    if(this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
      || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD'){
        this.getCompetencyNameForEmployeeTableTeamGraph();
    }else{
      this.getListOfEmployeeManager();
    }
    this.getCompetencyTrend();
    this.getCompetencyWiseEmployeeGraph();
    this.getComparisonEmployeeWiseList();
    this.getCompetencyYearonYear();
    this.getCompetencyYearWiseOnYearScore();
  }


  empsleectedformanagergraphview(selectedEmployeeDashboardForGraph: any) {
    this.selectedEmployeeDashboardId = selectedEmployeeDashboardForGraph;
    this.selectedEmployeeDashboardFullName = selectedEmployeeDashboardForGraph;
    this.getUserByID();
    this.getEmployeeScoreAndRating();
    this.getGlobalSummary();
    this.getWeightageWiseCompentenciesGraphs()
    this.getCompetencyTopBottomScore();
    this.getCompetencyNamesWiseYearOnScore();
    if(this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
      || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD'){
        this.getCompetencyNameForEmployeeTableTeamGraph();
    }else{
      this.getListOfEmployeeManager();
    }
    this.getCompetencyTrend();
    this.getCompetencyWiseEmployeeGraph();
    this.getComparisonEmployeeWiseList();
    this.getCompetencyYearonYear();
    this.getCompetencyYearWiseOnYearScore();
  }

  scoreForDashboard: number = 0;
  competencyRatingDashboard: string = '';

  getEmployeeScoreAndRating() {
    const Request = {
      companyId: this.loggedInUserCompanyID,
      employeeId: this.selectedEmployeeDashboardId,
      managerCode: this.selectedEmployeeIdForScoreAndRating,
      yearRange: this.selectedYearForCompetency,
    };

    this.httpService.callPostService(this.config.getEmployeeRatingAndScoreDashboard, Request)
      .subscribe((response: any) => {

        if (response && response.status) {
          this.scoreForDashboard = response.data.score;
          this.competencyRatingDashboard = response.data.competencRating;
        } else {
        }
      }, (error) => {
      });

  }

  functionsCount: string = '';
  bandsCount: string = '';
  totalPublishComp: string = '';
  competenciesSet: string = '';
  evaluatedCompetencies: string = '';


  getGlobalSummary() {
    const Request = {
      "companyId": this.loggedInUserCompanyID,
      "employeeId": this.selectedManagerDashboardId,
      "managerCode": this.selectedEmployeeIdForScoreAndRating,
      "topOrBottom": null,
      "yearRange": this.selectedYearForCompetency,
      "loggedInUserRole": this.loggedInUserRole,
    };

    this.httpService.callPostService(this.config.getGlobalSummaryDashboard, Request)
      .subscribe((response: any) => {
        if (response && response.status) {
          this.functionsCount = response.data.functionsCount;
          this.bandsCount = response.data.bandsCount;
          this.totalPublishComp = response.data.totalPublishComp;
          this.competenciesSet = response.data.competenciesSet;
          this.evaluatedCompetencies = response.data.evaluatedCompetencies;
        }
      }, (error) => {
      });
  }

  onSelectYearForGraphTwoHrAdmin() {
    var year = this.competencySetupInformationForm.value.year?.split('-');
    if (year && year.length === 2) {
      const fromYear = year[0];
      const toYear = year[1];
      this.competencySetupInformationForm.controls['fromYear'].setValue(fromYear);
      this.competencySetupInformationForm.controls['toYear'].setValue(toYear);
    }
    this.getCompetencyTopBottomScore()
  }

  weightageWiseCompetenciesGraphType: any = 'pie';
  showWeightagewiseCompetenciesTable: boolean = false;
  TopandBottonCompetencyByScoreGraphType: any = 'bar';
  CompetencyYearOnYearGraphType: any = 'bar';
  CompetencyTrendGraphType: any = 'bar';
  CompetencyWiseEmployeeGraphType: any = 'bar';
  showCompetencyWiseEmployeeTble: boolean = true;
  RatingWiseEmployeeCountGraphType: any = 'bar';

  ComparisonEmployeeWiseGraphType: any = 'bar';
  showComparisonEmployeeWiseTble: boolean = false;
  YearOnYearFinalScoreGraphType: any = 'line';
  showYearOnYearFinalScoreTble: boolean = false

  WeightagewiseCompetencies: any = {
    bar: {},
    pie: {},
    line: {},
  };
  TopandBottonCompetencyByScore: any = {
    bar: {},
    line: {},
    scatter: {}
  };
  competencyWiseYearOnYearScoreGraph: any = {
    bar: {},
    line: {},
  };
  CompetencyTrandGraph: any = {
    bar: {},
    line: {},
    scatter: {}
  };
  CompentencyWiseEmployeeGraphs: any = {
    bar: {},
    pie: {},
    line: {},
  };
  RatingWiseEmployeeCount: any = {
    bar: {},
    pie: {},
    line: {},
    scatter: {}
  };

  ComparisonEmployeeWise: any = {
    bar: {},
    pie: {},
    line: {},
    scatter: {}
  };
  YearOnYearFinalScore: any = {
    bar: {},
    pie: {},
    line: {},
    scatter: {}
  };

  // Weightage wise Competencies 
  onSelectYearForGraphOneHrAdmin() {
    var year = this.competencySetupInformationForm.value.year?.split('-');
    if (year && year.length === 2) {
      const fromYear = year[0];
      const toYear = year[1];
      this.competencySetupInformationForm.controls['fromYear'].setValue(fromYear);
      this.competencySetupInformationForm.controls['toYear'].setValue(toYear);
    }
    this.getWeightageWiseCompentenciesGraphs()
  }

  getWeightageWiseCompentenciesGraphs() {
    const Request = {
      "companyId": this.loggedInUserCompanyID,
      "employeeId": this.selectedEmployeeDashboardId,
      "managerCode": this.selectedEmployeeIdForScoreAndRating,
      "topOrBottom": null,
      "yearRange": this.selectedYearForGraphOneHRAdmin,
      "loggedInUserRole": this.loggedInUserRole
    };

    this.httpService.callPostService(this.config.getCompetencyWiseDashboard, Request)
      .subscribe((response: any) => {
        
        this.weightageWiseCompetenciesGraphData=[];
        if(response?.status){
          this.weightageWiseCompetenciesGraphData = response.data || [];
          this.initChartWeightageWiseCompetenciesGraphType();
          this.WeightagewiseCompetencies.bar = this.getBarWeightageWiseCompetencies(this.weightageWiseCompetenciesGraphData);
          this.WeightagewiseCompetencies.pie = this.getPieWeightageWiseCompetencies(this.weightageWiseCompetenciesGraphData);
          this.WeightagewiseCompetencies.line = this.getLineWeightageWiseCompetencies(this.weightageWiseCompetenciesGraphData);
          this.switchWeightageWiseCompetenciesGraphType('pie')
        }else{
          this.initChartWeightageWiseCompetenciesGraphType();
          this.WeightagewiseCompetencies.bar = this.getBarWeightageWiseCompetencies(this.weightageWiseCompetenciesGraphData);
          this.WeightagewiseCompetencies.pie = this.getPieWeightageWiseCompetencies(this.weightageWiseCompetenciesGraphData);
          this.WeightagewiseCompetencies.line = this.getLineWeightageWiseCompetencies(this.weightageWiseCompetenciesGraphData);
          this.switchWeightageWiseCompetenciesGraphType('pie')
        }
      });
  }
  chartWeightageWiseCompetenciesGraphs: echarts.ECharts | undefined;

  initChartWeightageWiseCompetenciesGraphType() {
    const dom = document.getElementById('WeightageWiseCompetenciesGraphs') as HTMLDivElement;
    this.chartWeightageWiseCompetenciesGraphs = echarts.init(dom);
    this.switchWeightageWiseCompetenciesGraphType('pie'); // Set default chart type
  }
  switchWeightageWiseCompetenciesGraphType(chartType: any) {
    this.weightageWiseCompetenciesGraphType = chartType
    this.showWeightagewiseCompetenciesTable = false;
    const dom = document.getElementById("WeightageWiseCompetenciesGraphs") as HTMLDivElement
    this.chartWeightageWiseCompetenciesGraphs = echarts.init(dom);
    if (this.chartWeightageWiseCompetenciesGraphs) {
      if (chartType == 'bar') {
        this.getBarWeightageWiseCompetencies(this.weightageWiseCompetenciesGraphData)
      }
      if (chartType == 'pie') {
        this.getPieWeightageWiseCompetencies(this.weightageWiseCompetenciesGraphData)
      }
      if (chartType == 'line') {
        this.getLineWeightageWiseCompetencies(this.weightageWiseCompetenciesGraphData)
      }
      if (this.WeightagewiseCompetencies[chartType] && typeof this.WeightagewiseCompetencies[chartType] === "object") {
        this.chartWeightageWiseCompetenciesGraphs.setOption(this.WeightagewiseCompetencies[chartType], true);
      }
    }
  }

  getBarWeightageWiseCompetencies(data: any): echarts.EChartsOption {
    const chartData = data.map((item: any) => ({
      value: item.wt,
      name: item.competencyName,
    }));
    return {
      tooltip: { trigger: 'axis' },
      legend: { show:true,bottom: 0 },
      xAxis: { show: true, data: chartData.map((ele: { name: any; }) => ele.name),
      name: 'Competency',nameLocation: 'middle',
      nameTextStyle: {
        fontSize: 14,
        padding: 6,
      },
      axisTick: {
        alignWithLabel: true,
      },
      },
      yAxis: { show: true, type: 'value', splitLine: { show: false },
        name: 'Weightage',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
        },
      },
      series: [
        {
          name: 'Competency',
          data: chartData.map((ele: { value: any; }) => ele.value),
          type: 'bar',
          barWidth: 20,
          label: { show: true, position: 'top' ,fontSize: 9 }
        }
      ],

      // tooltip: { trigger: 'axis' },
      // legend: { bottom: 10 },
      // color: ['#F3820E'],
      // xAxis: {
      //   data: data.map((ele: { competencyName: any; }) => ele.competencyName)
      // },
      // yAxis: {
      //   type: 'value'
      // },
      // series: [
      //   {
      //     data: data.map((ele: { score: any; }) => ele.score),
      //     type: 'bar',
      //     barWidth: '20%'
      //   }
      // ],
      // grid: {
      //   top: '15%',
      //   left: '1%',
      //   right: '0%',
      //   bottom: '10%',
      //   containLabel: true
      // },
      // toolbox: {
      //   show: true,
      //   iconStyle: { borderColor: '#F3820E' }
      // },
    };
  }

  getPieWeightageWiseCompetencies(data: any): echarts.EChartsOption {
    const chartData = data.map((item: any) => ({
      value: item.wt,
      name: item.competencyName,
      achived: item.achived,
      score: item.score,
      wt: item.wt
    }));

    return {
      tooltip: {
        trigger: 'item'
      },
      legend: {
        bottom: 0,
     },
      series: [
        {
          name: 'Competency Weightage',
          type: 'pie',
          label: {
            show: true,
            formatter: '{c}',
            fontSize: 14,
            fontWeight: 'bold',
            color: '#000',
            position: 'inside',
          },
          emphasis: {
            label: {
              show: true,
              formatter: '{c}',
              fontSize: 14,
              fontWeight: 'bold',
              color: '#000',
              position: 'inside',
            }
          },
          labelLine: {
            show: false
          },
          data: chartData
        }
      ],
      xAxis: { show: false },  // Hide xAxis for pie chart
      yAxis: { show: false }
    }
  }

  getLineWeightageWiseCompetencies(data: any): echarts.EChartsOption {
    const chartData = data.map((item: any) => ({
      value: item.wt,
      name: item.competencyName,
    }));
    return {
      xAxis: {
        data: chartData.map((ele: { name: any; }) => ele.name),
        name: 'Competency',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 6,
        },
        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: { splitLine: { show: false },
      name: 'Weightage',
      nameLocation: 'middle',
      nameTextStyle: {
        fontSize: 14,
        padding: 18
      },},
      series: [
        {
          name: 'Competency',
          data: chartData.map((ele: { value: any; }) => ele.value),
          type: 'line',
          label: {
            show: true,
            position: 'bottom',
          }
        }
      ],
      legend: { bottom: 10 },
    }
  }

  onClickTableWeightageWiseCompetencies() {
    this.weightageWiseCompetenciesGraphType = ''
    this.showWeightagewiseCompetenciesTable = true;
  }

  downloadWeightageWiseCompetenciesGraph(){
   const year = this.sharedService.transformYearToFyFormat(this.selectedYearForGraphOneHRAdmin)

    this.pdfDownload.competencyGraphPDFdownload(
      'WeightageWiseCompetenciesGraphs', // chartId
      'WeightageWiseCompetenciesTable', // tableId
      'Weightage wise Competencies', // Title
      year, // Year
      null, // score
      null, // Competency Name
      null, // Employee Name
    ); 
  }

  //Top and Botton Competency by score
  onOptionChange(value: string) {
    this.selectedOption = value;
    this.getCompetencyTopBottomScore()
  }

  getCompetencyTopBottomScore() {
    const Request = {
      companyId: this.loggedInUserCompanyID,
      employeeId: this.selectedEmployeeDashboardId,
      managerCode: this.selectedEmployeeIdForScoreAndRating,
      topOrBottom: this.selectedOption,
      yearRange: this.selectedYearForGraphTwoHRAdmin,
      loggedInUserRole: this.loggedInUserRole
    };

    this.httpService.callPostService(this.config.getCompetencyTobottomScore, Request)
      .subscribe((data: any) => {
        this.graphDataForLineGraph=[];
        if(data?.status){
          this.graphDataForLineGraph = data.data;
          this.TopandBottonCompetencyByScore.bar = this.getBarTopandBottonCompetencyByScore(this.graphDataForLineGraph);
          this.TopandBottonCompetencyByScore.line = this.getLineTopandBottonCompetencyByScore(this.graphDataForLineGraph);
          this.TopandBottonCompetencyByScore.scatter = this.getScatterTopandBottonCompetencyByScore(this.graphDataForLineGraph);
          this.switchTandBCompetencyScoreGraphType('bar')
        }else{
          this.TopandBottonCompetencyByScore.bar = this.getBarTopandBottonCompetencyByScore(this.graphDataForLineGraph);
          this.TopandBottonCompetencyByScore.line = this.getLineTopandBottonCompetencyByScore(this.graphDataForLineGraph);
          this.TopandBottonCompetencyByScore.scatter = this.getScatterTopandBottonCompetencyByScore(this.graphDataForLineGraph);
          this.switchTandBCompetencyScoreGraphType('bar')
        }
      });
  }

  switchTandBCompetencyScoreGraphType(chartType: any) {
    this.TopandBottonCompetencyByScoreGraphType = chartType;
    const dom = document.getElementById("topBottomGraph") as HTMLDivElement
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (chartType == 'bar') {
        this.getBarTopandBottonCompetencyByScore(this.graphDataForLineGraph)
      }
      if (chartType == 'line') {
        this.getLineTopandBottonCompetencyByScore(this.graphDataForLineGraph)
      }
      if (chartType == 'scatter') {
        this.getScatterTopandBottonCompetencyByScore(this.graphDataForLineGraph)
      }
      if (this.TopandBottonCompetencyByScore[chartType] && typeof this.TopandBottonCompetencyByScore[chartType] === "object") {
        chartEmpTaskStatus.setOption(this.TopandBottonCompetencyByScore[chartType], true);
      }
    }
  }

  getBarTopandBottonCompetencyByScore(data: any): echarts.EChartsOption {
    return {
      color: ['#F3820E'],
      tooltip: { trigger: 'axis' },
      xAxis: {
        data: data.map((ele: { competencyName: any; }) => ele.competencyName),
        name: 'Competency',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 6,
        },
        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: {
        type: 'value',
        splitLine: { show: false },
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
        },
      },
      dataZoom: [{ // Add dataZoom here
        type: 'slider',
        start: 0,
        end: 100,
        handleSize: '100%',
        showDetail: false,
        xAxisIndex: [0],
      }],
      series: [
        {
          name: 'Competency',
          data: data.map((ele: { score: any; }) => ele.score),
          type: 'bar',
          barWidth: 20,
          label: { show: true, position: 'top' ,fontSize: 9 }
        }
      ],
      // grid: {
      //   top: '15%',
      //   left: '1%',
      //   right: '0%',
      //   bottom: '10%',
      //   containLabel: true
      // },
      toolbox: {
        show: true,
        iconStyle: { borderColor: '#F3820E' }
      },
      legend: { bottom: 0 },
    };
  }

  getLineTopandBottonCompetencyByScore(data: any): echarts.EChartsOption {
    return {
      xAxis: {
        data: data.map((ele: { competencyName: any; }) => ele.competencyName),
        name: 'Competency',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 6,
        },
        axisTick: {
          alignWithLabel: true,
        },
      },
      dataZoom: [{ // Add dataZoom here
        type: 'slider',
        start: 0,
        end: 100,
        handleSize: '100%',
        showDetail: false,
        xAxisIndex: [0],
        bottom: 20
      }],
      yAxis: { splitLine: { show: false },
      name: 'Score',
      nameLocation: 'middle',
      nameTextStyle: {
        fontSize: 14,
        padding: 18
      },},
      series: [
        {
          name: 'Competency',
          data: data.map((ele: { score: any; }) => ele.score),
          type: 'line',
          label: {
            show: true,
            position: 'top',
          }
        }
      ],
      legend: { bottom: 50 },
    }
  }

  getScatterTopandBottonCompetencyByScore(data: any): echarts.EChartsOption {
    return {
      xAxis: {
        data: data.map((ele: { competencyName: any; }) => ele.competencyName),
        name: 'Competency',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 6,
        },
        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: { splitLine: { show: false },
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
      },},
      dataZoom: [{ // Add dataZoom here
        type: 'slider',
        start: 0,
        end: 100,
        handleSize: '100%',
        showDetail: false,
        xAxisIndex: [0],
      }],
      series: [
        {
          name: 'Competency',
          type: 'scatter',
          data: data.map((ele: { score: any; }) => ele.score),
          label: {show: true,position: 'bottom'}
        }
      ],
      legend: { bottom: 10 },
    }
  }

  downloadTopAndBottomByScoreGraph(){
   const year = this.sharedService.transformYearToFyFormat(this.selectedYearForGraphOneHRAdmin)

    this.pdfDownload.competencyGraphPDFdownload(
      'topBottomGraph', // chartId
      null, // tableId
      'Top and Bottom Competency by score', // Title
      year, // Year
      this.selectedOption, // score
      null, // Competency Name
      null, // Employee Name
    ); 
  }


  // competency wise year on year score

  onCompetencyChange(event: any) {
    this.getCompetencyYearWiseOnYearScore();
  }

  getCompetencyNamesWiseYearOnScore() {
    this.httpService.callGetService(
      this.config.getUniqeCompetencyDropdowns +
      this.loggedInUserCompanyID + '/' +
      this.selectedEmployeeDashboardId + '/' +
      this.selectedYearForCompetency
    ).subscribe((data: any) => {
      
      if (data.status) {
        this.SelectCompetencyDropdownListForGraph =[];
        data?.data?.forEach((ele: any) => {
          let obj = {
            id: ele,
            itemName: ele,
          }
          this.SelectCompetencyDropdownListForGraph.push(obj);
        });
        this.SelectCompetencyDropdownListForGraph = this.SelectCompetencyDropdownListForGraph.sort((a: any, b: any) => a.itemName.localeCompare(b.itemName));
        if(this.SelectCompetencyDropdownListForGraph.length!=0){
          this.selectedCompetencyForEmployeeDashboard = this.SelectCompetencyDropdownListForGraph[0].id;
          this.getCompetencyYearWiseOnYearScore();
        }
      }
    });
  }

  getCompetencyYearWiseOnYearScore() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      employeeId: this.selectedEmployeeDashboardId,
      managerCode: this.selectedEmployeeIdForScoreAndRating,
      yearRange: this.selectedYearForCompetency,
      competencyName: this.selectedCompetencyForEmployeeDashboard,
      subCompetencyId: null,
      loggedInUserRole: this.loggedInUserRole
    };

    this.httpService.callPostService(this.config.getYearwiseCompetencyGraphData, request)
      .subscribe((data: any) => {
        this.competencyYearOneYearData = [];
        if(data?.status){
          const graphData = data.data.graphDataBean;
          this.competencyYearOneYearData = graphData;
          this.competencyWiseYearOnYearScoreGraph.bar = this.getBarCompetencyYearOnYearScoreGraph(this.competencyYearOneYearData);
          this.competencyWiseYearOnYearScoreGraph.line = this.getLineCompetencyYearOnYearScoreGraph(this.competencyYearOneYearData);
          this.switchCompetencyYearOnYearGraphType('bar')
        }else{
          this.competencyWiseYearOnYearScoreGraph.bar = this.getBarCompetencyYearOnYearScoreGraph(this.competencyYearOneYearData);
          this.competencyWiseYearOnYearScoreGraph.line = this.getLineCompetencyYearOnYearScoreGraph(this.competencyYearOneYearData);
          this.switchCompetencyYearOnYearGraphType('bar')
        }
      });
  }

  switchCompetencyYearOnYearGraphType(chartType: any) {
    this.CompetencyYearOnYearGraphType = chartType;
    const dom = document.getElementById("CompetencyWiseYearScore") as HTMLDivElement
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (chartType == 'bar') {
        this.getBarCompetencyYearOnYearScoreGraph(this.competencyYearOneYearData)
      }
      if (chartType == 'line') {
        this.getLineCompetencyYearOnYearScoreGraph(this.competencyYearOneYearData)
      }
      if (this.competencyWiseYearOnYearScoreGraph[chartType] && typeof this.competencyWiseYearOnYearScoreGraph[chartType] === "object") {
        chartEmpTaskStatus.setOption(this.competencyWiseYearOnYearScoreGraph[chartType], true);
      }
    }
  }


  getBarCompetencyYearOnYearScoreGraph(data: any): echarts.EChartsOption {
    return {
      color: ['#F3820E'],
      tooltip: { trigger: 'axis' },
      xAxis: {
        data: data.map((ele: { year: any; }) => ele.year),
        name: 'Competency',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 6,
        },
        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: {
        type: 'value',
        splitLine: { show: false },
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
      },
      },
      series: [
        {
          name: 'Competency',
          data: data.map((ele: { score: any; }) => ele.score),
          type: 'bar',
          barWidth: 20,
          label: { show: true, position: 'top' ,fontSize: 9 }
        }
      ],
      // grid: {
      //   top: '15%',
      //   left: '1%',
      //   right: '0%',
      //   bottom: '10%',
      //   containLabel: true
      // },
      toolbox: {
        show: true,
        iconStyle: { borderColor: '#F3820E' }
      },
      legend: { bottom: 10 },
    };
  }

  getLineCompetencyYearOnYearScoreGraph(data: any): echarts.EChartsOption {
    return {
      xAxis: {
        data: data.map((ele: { year: any; }) => ele.year),
        name: 'Competency',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 6,
        },
        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: { splitLine: { show: false },
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
      },},
      series: [
        {
          name: 'Competency',
          data: data.map((ele: { score: any; }) => ele.score),
          type: 'line',
          label: {
            show: true,
            position: 'bottom',
          }
        }
      ],
      legend: { bottom: 10 },
    }
  }

  downloadCompetencyWiseYearScoreGraph(){
    this.pdfDownload.competencyGraphPDFdownload(
      'CompetencyWiseYearScore', // chartId
      null, // tableId
      'Competency wise Year on Year Score', // Title
      null, // Year
      null, // score
      this.selectedCompetencyForEmployeeDashboard, // Competency Name
      null, // Employee Name
    ); 
  }

  //API Competency Trand 

  getCompetencyTrend() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      employeeId: this.selectedEmployeeDashboardId,
      managerCode: null,
      yearRange: this.selectedYearForCompetency,
      loggedInUserRole: this.loggedInUserRole
    };

    this.httpService.callPostService(this.config.getCompetencyTrend, request)
      .subscribe((data: any) => {
        this.graphDataForCompetencyTrend = [];
        if(data.status){
          const graphData = data.data;
          this.graphDataForCompetencyTrend = graphData;
          this.CompetencyTrandGraph.bar = this.getBarCompetencyTrendGraph(this.graphDataForCompetencyTrend);
          this.CompetencyTrandGraph.line = this.getLineCompetencyTrendGraph(this.graphDataForCompetencyTrend);
          this.CompetencyTrandGraph.scatter = this.getScatterCompetencyTrendGraph(this.graphDataForCompetencyTrend);
          this.switchCompetencyTrendGraphType('bar')
        }else{
          this.CompetencyTrandGraph.bar = this.getBarCompetencyTrendGraph(this.graphDataForCompetencyTrend);
          this.CompetencyTrandGraph.line = this.getLineCompetencyTrendGraph(this.graphDataForCompetencyTrend);
          this.CompetencyTrandGraph.scatter = this.getScatterCompetencyTrendGraph(this.graphDataForCompetencyTrend);
          this.switchCompetencyTrendGraphType('bar')
        }
      });
  }

  switchCompetencyTrendGraphType(chartType: any) {
    this.CompetencyTrendGraphType = chartType;
    const dom = document.getElementById("CompetencyTrend") as HTMLDivElement
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (chartType == 'bar') {
        this.getBarCompetencyTrendGraph(this.graphDataForCompetencyTrend)
      }
      if (chartType == 'line') {
        this.getLineCompetencyTrendGraph(this.graphDataForCompetencyTrend)
      }
      if (chartType == 'scatter') {
        this.getScatterCompetencyTrendGraph(this.graphDataForCompetencyTrend)
      }
      if (this.CompetencyTrandGraph[chartType] && typeof this.CompetencyTrandGraph[chartType] === "object") {
        chartEmpTaskStatus.setOption(this.CompetencyTrandGraph[chartType], true);
      }
    }
  }

  getBarCompetencyTrendGraph(data: any): echarts.EChartsOption {
    return {
      color: ['#F3820E'],
      tooltip: { trigger: 'axis' },
      xAxis: {
        data: data.map((ele: { year: any; }) => ele.year),
        name: 'Competency',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 6,
        },
        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: {
        type: 'value',
        splitLine: { show: false },
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
      }
      },
      series: [
        {
          name: 'Competency Score',
          data: data.map((ele: { score: any; }) => ele.score),
          type: 'bar',
          barWidth: 20,
          label: { show: true, position: 'top' ,fontSize: 9 }
        },
        {
          name: 'Average Score',
          type: 'line',
          data: data.map((ele: { score: any; }) => ele.score),
          symbol: 'none', // Hides the line markers
          lineStyle: {
              type: 'dashed',
              color: 'gray'
          },
          markLine: {
              data: [
                  {
                      type: 'average',
                      name: 'Average Score'
                  }
              ]
          }
      }
      ],
      // grid: {
      //   top: '15%',
      //   left: '1%',
      //   right: '0%',
      //   bottom: '10%',
      //   containLabel: true
      // },
      toolbox: {
        show: true,
        iconStyle: { borderColor: '#F3820E' }
      },
      legend: { bottom: 10 },
    };
  }

  getLineCompetencyTrendGraph(data: any): echarts.EChartsOption {
    return {
      xAxis: {
        data: data.map((ele: { year: any; }) => ele.year),
        name: 'Competency',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 6,
        },
        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: { splitLine: { show: false },
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
      }},
      series: [
        {
          name: 'Competency Score',
          data: data.map((ele: { score: any; }) => ele.score),
          type: 'line',
          label: {
            show: true,
            position: 'bottom',
          }
        },
        {
          name: 'Average Score',
          type: 'line',
          data: data.map((ele: { score: any; }) => ele.score),
          symbol: 'none', // Hides the line markers
          lineStyle: {
              type: 'dashed',
              color: 'gray'
          },
          markLine: {
              data: [
                  {
                      type: 'average',
                      name: 'Average Score'
                  }
              ]
          }
      }
      ],
      legend: { bottom: 10 },
    }
  }

  getScatterCompetencyTrendGraph(data: any): echarts.EChartsOption {
    return {
      xAxis: {
        data: data.map((ele: { year: any; }) => ele.year),
        name: 'Competency',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 6,
        },
        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: { splitLine: { show: false },
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
      }},
      series: [
        {
          name: 'Competency Score',
          type: 'scatter',
          data: data.map((ele: { score: any; }) => ele.score),
          label: {show: true,position: 'bottom'}
        },
        {
          name: 'Average Score',
          type: 'line',
          data: data.map((ele: { score: any; }) => ele.score),
          symbol: 'none', // Hides the line markers
          lineStyle: {
              type: 'dashed',
              color: 'gray'
          },
          markLine: {
              data: [
                  {
                      type: 'average',
                      name: 'Average Score'
                  }
              ]
          }
      }
      ],
      legend: { bottom: 10 },
    }
  }

  downloadCompetencyTrendGraph(){
    this.pdfDownload.competencyGraphPDFdownload(
      'CompetencyTrend', // chartId
      null, // tableId
      'Competency Trend', // Title
      null, // Year
      null, // score
      null, // Competency Name
      null, // Employee Name
    ); 
  }

  // Competency Wise Employee

  onCompetencyChangeForTeamGraphOne(event: any) {
    this.competencyWiseEmployeeGraph();
  }

  competencyWiseEmployeeGraph() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      competencyName: this.selectedCompetencyForEmployeeTableTeamGraphView,
      managerCode: this.loggedInUserEmpCode,
      "subCompetencyId": 0,
      yearRange: this.selectedYearForCompetency,
    };

    this.httpService.callPostService(this.config.getCompetencyWiseEmployeeTable, request)
      .subscribe((data: any) => {
        this.graphDataForCompetencyWiseEmployee = [];
        if(data.status){
        this.graphDataForCompetencyWiseEmployee = data.data
        // this.CompentencyWiseEmployeeGraphs.bar = this.getBarCompetencyWiseEmployeeGraph(this.graphDataForCompetencyWiseEmployee);
        // this.CompentencyWiseEmployeeGraphs.pie = this.getPieCompetencyWiseEmployeeGraph(this.graphDataForCompetencyWiseEmployee);
        // this.CompentencyWiseEmployeeGraphs.line = this.getLineCompetencyWiseEmployeeGraph(this.graphDataForCompetencyWiseEmployee);
        // this.switchCompetencyWiseEmployeeGraphType('bar')
        }
      });
  }

  switchCompetencyWiseEmployeeGraphType(chartType: any) {
    this.CompetencyWiseEmployeeGraphType = chartType;
    this.showCompetencyWiseEmployeeTble = true;

    const dom = document.getElementById("CompetencyWiseEmployee") as HTMLDivElement
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (chartType == 'bar') {
        this.getBarCompetencyWiseEmployeeGraph(this.graphDataForCompetencyWiseEmployee)
      }
      if (chartType == 'pie') {
        this.getPieCompetencyWiseEmployeeGraph(this.graphDataForCompetencyWiseEmployee)
      }
      if (chartType == 'line') {
        this.getLineCompetencyWiseEmployeeGraph(this.graphDataForCompetencyWiseEmployee)
      }
      if (this.CompentencyWiseEmployeeGraphs[chartType] && typeof this.CompentencyWiseEmployeeGraphs[chartType] === "object") {
        chartEmpTaskStatus.setOption(this.CompentencyWiseEmployeeGraphs[chartType], true);
      }
    }
  }

  getBarCompetencyWiseEmployeeGraph(data: any): echarts.EChartsOption {
    return {
      color: ['#F3820E'],
      tooltip: { trigger: 'axis' },
      xAxis: {
        type: 'category',
        data: data.map((ele: { empName: any; }) => ele.empName),
        name: 'Competency',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 6,
        },
        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: {
        type: 'value',
        splitLine: { show: false },
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
      }
      },
      series: [
        {
          name:'Competency',
          data: data.map((ele: { score: any; }) => ele.score),
          type: 'bar',
          barWidth: 20,
          label: { show: true, position: 'top' ,fontSize: 9 }
        }
      ],
      // grid: {
      //   top: '15%',
      //   left: '1%',
      //   right: '0%',
      //   bottom: '10%',
      //   containLabel: true
      // },
      toolbox: {
        show: true,
        iconStyle: { borderColor: '#F3820E' }
      },
      legend: { bottom: 10 },
    };
  }

  getPieCompetencyWiseEmployeeGraph(data: any): echarts.EChartsOption {
    const chartData = data.map((item: any) => ({
      value: item.score,
      name: item.empName,
      achived: item.achived,
      score: item.score,
      wt: item.wt
    }));

    return {
      series: [
        {
          name:'Competency',
          type: 'pie',
          radius: '50%',
          data: chartData,
          label: {
            show: true,
            formatter: '{c}',
            fontSize: 14,
            fontWeight: 'bold',
            color: '#000',
            position: 'inside',
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ],
      legend: { bottom: 10 },
    }
  }

  getLineCompetencyWiseEmployeeGraph(data: any): echarts.EChartsOption {
    return {
      xAxis: {
        data: data.map((ele: { empName: any; }) => ele.empName),
        name: 'Competency',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 6,
        },
        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: { splitLine: { show: false },
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
      }},
      series: [
        {
          name:'Competency',
          data: data.map((ele: { score: any; }) => ele.score),
          type: 'line',
          label: {
            show: true,
            position: 'bottom',
          }
        }
      ],
      legend: { bottom: 10 },
    }
  }

  onClickTableCompetencyWiseEmployee() {
    this.CompetencyWiseEmployeeGraphType = ''
    this.showCompetencyWiseEmployeeTble = true;
  }

  downloadCompetencyWiseEmpGraph(){
   const year = this.sharedService.transformYearToFyFormat(this.selectedYearForGraphFifthHRAdmin)

    this.pdfDownload.competencyGraphPDFdownload(
      null, // chartId
      'competencyWiseEmployeeTable', // tableId
      'Competency Wise Employee', // Title
      year, // Year
      null, // score
      this.selectedCompetencyForEmployeeTableTeamGraphView, // Competency Name
      null, // Employee Name
    ); 
  }

  // Rating-wise Employee count

  onSelectYearForGraphSixHrAdmin() {
    var year = this.competencySetupInformationForm.value.year?.split('-');
    if (year && year.length === 2) {
      const fromYear = year[0];
      const toYear = year[1];
      this.competencySetupInformationForm.controls['fromYear'].setValue(fromYear);
      this.competencySetupInformationForm.controls['toYear'].setValue(toYear);
    }
    this.getCompetencyWiseEmployeeGraph();
  }

  getCompetencyWiseEmployeeGraph() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      employeeId: null,
      managerCode: this.loggedInUserEmpCode,
      yearRange: this.selectedYearForGraphSix,
    };

    this.httpService.callPostService(this.config.getCompetencyWiseEmployeeGraph, request)
      .subscribe((data: any) => {
        this.graphDataForRatingWiseEmployeeCount = [];
        
        if(data.status){
          this.graphDataForRatingWiseEmployeeCount = data.data
          this.RatingWiseEmployeeCount.bar = this.getBarRatingWiseEmployeeCountGraph(this.graphDataForRatingWiseEmployeeCount);
          this.RatingWiseEmployeeCount.pie = this.getPieRatingWiseEmployeeCountGraph(this.graphDataForRatingWiseEmployeeCount);
          this.RatingWiseEmployeeCount.line = this.getLineRatingWiseEmployeeCountGraph(this.graphDataForRatingWiseEmployeeCount);
          this.RatingWiseEmployeeCount.scatter = this.getScatterRatingWiseEmployeeCountGraph(this.graphDataForRatingWiseEmployeeCount);
          this.switchRatingWiseEmployeeCountGraphType('bar')
        }else{
          this.RatingWiseEmployeeCount.bar = this.getBarRatingWiseEmployeeCountGraph(this.graphDataForRatingWiseEmployeeCount);
          this.RatingWiseEmployeeCount.pie = this.getPieRatingWiseEmployeeCountGraph(this.graphDataForRatingWiseEmployeeCount);
          this.RatingWiseEmployeeCount.line = this.getLineRatingWiseEmployeeCountGraph(this.graphDataForRatingWiseEmployeeCount);
          this.RatingWiseEmployeeCount.scatter = this.getScatterRatingWiseEmployeeCountGraph(this.graphDataForRatingWiseEmployeeCount);
          this.switchRatingWiseEmployeeCountGraphType('bar')
        }
      });
  }
  showRatingWiseEmpTble:boolean=false;
  onClickTableRatingWiseEmp(){
    this.showRatingWiseEmpTble=true;
    this.RatingWiseEmployeeCountGraphType = '';

  }
  switchRatingWiseEmployeeCountGraphType(chartType: any) {
    this.RatingWiseEmployeeCountGraphType = chartType;
    this.showRatingWiseEmpTble=false;
    const dom = document.getElementById("ratingWiseEmployeeCount") as HTMLDivElement
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (chartType == 'bar') {
        this.getBarRatingWiseEmployeeCountGraph(this.graphDataForRatingWiseEmployeeCount)
      }
      if (chartType == 'pie') {
        this.getPieRatingWiseEmployeeCountGraph(this.graphDataForRatingWiseEmployeeCount)
      }
      if (chartType == 'line') {
        this.getLineRatingWiseEmployeeCountGraph(this.graphDataForRatingWiseEmployeeCount)
      }
      if (chartType == 'scatter') {
        this.getScatterRatingWiseEmployeeCountGraph(this.graphDataForRatingWiseEmployeeCount)
      }
      if (this.RatingWiseEmployeeCount[chartType] && typeof this.RatingWiseEmployeeCount[chartType] === "object") {
        chartEmpTaskStatus.setOption(this.RatingWiseEmployeeCount[chartType], true);
      }
    }
  }

  getBarRatingWiseEmployeeCountGraph(data: any): echarts.EChartsOption {
    return {
      color: ['#F3820E'],
      tooltip: { trigger: 'axis' },
      xAxis: {
        type: 'category',
        data: data.map((ele: { rating: any; }) => ele.rating),
        name: 'Rating',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 6,
        },
        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: {
        type: 'value',
        splitLine: { show: false },
        name: 'Employee Count',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
      }
      },
      series: [
        {
          name:'Rating',
          data: data.map((ele: { empCount: any; }) => ele.empCount),
          type: 'bar',
          barWidth: 20,
          label: { show: true, position: 'top' ,fontSize: 9 }
        }
      ],
      // grid: {
      //   top: '15%',
      //   left: '1%',
      //   right: '0%',
      //   bottom: '10%',
      //   containLabel: true
      // },
      toolbox: {
        show: true,
        iconStyle: { borderColor: '#F3820E' }
      },
      legend: { bottom: 10 },
    };
  }

  getPieRatingWiseEmployeeCountGraph(data: any): echarts.EChartsOption {
    const chartData = data.map((item: any) => ({
      value: item.empCount,
      name: item.rating,
      achived: item.achived,
      score: item.score,
      wt: item.wt
    }));

    return {
      series: [
        {
          name: 'Competency Weightage',
          type: 'pie',
          radius: '50%',
          data: chartData,
          label: {
            show: true,
            formatter: '{c}',
            fontSize: 14,
            fontWeight: 'bold',
            color: '#000',
            position: 'inside',
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ],
      legend: { bottom: 10 },
    }
  }

  getLineRatingWiseEmployeeCountGraph(data: any): echarts.EChartsOption {
    return {
      xAxis: {
        data: data.map((ele: { rating: any; }) => ele.rating),
        name: 'Rating',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 6,
        },
        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: { splitLine: { show: false },
        name: 'Employee Count',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
      }},
      series: [
        {
          name:'Rating',
          data: data.map((ele: { empCount: any; }) => ele.empCount),
          type: 'line',
          label: {
            show: true,
            position: 'bottom',
          }
        }
      ],
      legend: { bottom: 10 },
    }
  }

  getScatterRatingWiseEmployeeCountGraph(data: any): echarts.EChartsOption {
    return {
      xAxis: {
        data: data.map((ele: { rating: any; }) => ele.rating),
        name: 'Rating',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 6,
        },
        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: { splitLine: { show: false },
        name: 'Employee Count',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
      }},
      series: [
        {
          name:'Rating',
          type: 'scatter',
          data: data.map((ele: { empCount: any; }) => ele.empCount),
          label: {show: true,position: 'bottom'}
        }
      ],
      legend: { bottom: 10 },
    }
  }

  downloadRatingWiseEmpcountGraph(){
   const year = this.sharedService.transformYearToFyFormat(this.selectedYearForGraphSix)

    this.pdfDownload.competencyGraphPDFdownload(
      'ratingWiseEmployeeCount', // chartId
      'ratingWiseEmployeeCountTable', // tableId
      'Rating-wise Employee count', // Title
      year, // Year
      null, // score
      null, // Competency Name
      null, // Employee Name
    ); 
  }

  // Comparison Employee wise

  onSelectYearForGraphNineHrAdmin() {
    var year = this.competencySetupInformationForm.value.year?.split('-');
    if (year && year.length === 2) {
      const fromYear = year[0];
      const toYear = year[1];
      this.competencySetupInformationForm.controls['fromYear'].setValue(fromYear);
      this.competencySetupInformationForm.controls['toYear'].setValue(toYear);
    }
  }

  getComparisonEmployeeWiseList() {
    this.httpService.callGetService(this.config.getCompetencyEmpList + this.loggedInUserCompanyID + '/' + this.selectedYearForCompetency)
      .subscribe((data: any) => {
        this.ComparisonEmployeeWiseList = [];
        if (data?.status) {
          data?.data?.forEach((ele: any) => {
            let obj = {
              id: ele,
              itemName: ele,
            }
            this.ComparisonEmployeeWiseList.push(obj);
          });
          this.ComparisonEmployeeWiseList = this.ComparisonEmployeeWiseList.sort((a: any, b: any) => a.itemName.localeCompare(b.itemName));
          
          if(this.ComparisonEmployeeWiseList.length!=0){
            this.selectedCompetencyName=this.ComparisonEmployeeWiseList[0].id;
            if(this.loggedInUserRole == 'Manager'|| this.loggedInUserRole == 'HOD'){
              this.comparisonEmployeesSelectionManagerView();
            }
            if(this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin'
              || this.loggedInUserRole == 'MD'){
                this.comparisonEmployeesSelectionHR();
            }          
          }
        }
      });
  }

  onCompSelect(event: any) {
    if(this.loggedInUserRole == 'Manager'|| this.loggedInUserRole == 'HOD'){
      this.comparisonEmployeesSelectionManagerView();
    }
    if(this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin'
      || this.loggedInUserRole == 'MD'){
        this.comparisonEmployeesSelectionHR();
    }
  }

  comparisonEmployeesSelectionHR() {
    this.httpService.callGetService(this.config.getCompetencyEmployeesMultipleByHrAdmin + this.loggedInUserCompanyID + '/' + this.selectedYearForCompetency + '/' + this.selectedCompetencyName)
      .subscribe((data: any) => {
        
        if (data && data.data && Array.isArray(data.data)) {
          this.employeesListComparisonSelected = data.data.map((employee: any) => {
            return {
              itemName: `${employee.firstName} ${employee.lastName}`,
              id: employee.id
            };
          });
          this.employeesListComparisonSelected = this.employeesListComparisonSelected.sort((a: any, b: any) => a.itemName.localeCompare(b.itemName));
        }
        if(this.employeesListComparisonSelected.length!=0){
          this.comparisonEmployeesSelectMultiple = [];
          this.comparisonEmployeesSelectMultiple.push({id:this.employeesListComparisonSelected[0].id,itemName:this.employeesListComparisonSelected[0].itemName});
          this.comparisonEmpIdsForSecondLast.push(this.comparisonEmployeesSelectMultiple);
          this.getComparisonEmployeeWiseGraph();
        } else {
          this.employeesListComparisonSelected = [];
        }
      });
  }

  onComparisonEmpSelect(selectedItems: any) {
    this.comparisonEmpIdsForSecondLast = [];
    if (Array.isArray(selectedItems) && selectedItems.length > 0) {
      selectedItems.forEach((item: any) => {
        if (item && item.id) {
          this.comparisonEmpIdsForSecondLast.push(item.id);
        }
      });
    }
    this.getComparisonEmployeeWiseGraph()
  }
  onSelectAllComparisonEmployeeWise(item:any){
    this.comparisonEmployeesSelectMultiple=item;
    this.getComparisonEmployeeWiseGraph();
  }
  onDeselectAllComparisonEmployeeWise(){
    this.comparisonEmployeesSelectMultiple=[];
    this.getComparisonEmployeeWiseGraph();
  }
  getComparisonEmployeeWiseGraph() {
    
    const request = {
      companyId: this.loggedInUserCompanyID,
      competencyName: this.selectedCompetencyName,
      employeeId: this.comparisonEmployeesSelectMultiple.map((ele:any)=>ele.id),
      managerCode: null,
      yearRange: this.selectedYearForGraphNineHRAdmin,
    };

    this.httpService.callPostService(this.config.getCompetencyComparisonGraph, request)
      .subscribe((data: any) => {
        this.graphDataForComparisonEmployeeWise = [];
        if(data.status){
          const graphData = data.data;
          this.graphDataForComparisonEmployeeWise = graphData;
          this.ComparisonEmployeeWise.bar = this.getBarComparisonEmployeeWiseGraph(this.graphDataForComparisonEmployeeWise);
          this.ComparisonEmployeeWise.pie = this.getPieComparisonEmployeeWiseGraph(this.graphDataForComparisonEmployeeWise);
          this.ComparisonEmployeeWise.line = this.getLineComparisonEmployeeWiseGraph(this.graphDataForComparisonEmployeeWise);
          this.ComparisonEmployeeWise.scatter = this.getScatterComparisonEmployeeWiseGraph(this.graphDataForComparisonEmployeeWise);
          this.switchComparisonEmployeeWiseGraphType('bar')
        }else{
          this.ComparisonEmployeeWise.bar = this.getBarComparisonEmployeeWiseGraph(this.graphDataForComparisonEmployeeWise);
          this.ComparisonEmployeeWise.pie = this.getPieComparisonEmployeeWiseGraph(this.graphDataForComparisonEmployeeWise);
          this.ComparisonEmployeeWise.line = this.getLineComparisonEmployeeWiseGraph(this.graphDataForComparisonEmployeeWise);
          this.ComparisonEmployeeWise.scatter = this.getScatterComparisonEmployeeWiseGraph(this.graphDataForComparisonEmployeeWise);
          this.switchComparisonEmployeeWiseGraphType('bar')
        }
      });
  }


  switchComparisonEmployeeWiseGraphType(chartType: any) {
    this.ComparisonEmployeeWiseGraphType = chartType
    this.showComparisonEmployeeWiseTble = false;

    const dom = document.getElementById("comparisonEmployeewiseGraph") as HTMLDivElement
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (chartType == 'bar') {
        this.getBarComparisonEmployeeWiseGraph(this.graphDataForComparisonEmployeeWise)
      }
      if (chartType == 'pie') {
        this.getPieComparisonEmployeeWiseGraph(this.graphDataForComparisonEmployeeWise)
      }
      if (chartType == 'line') {
        this.getLineComparisonEmployeeWiseGraph(this.graphDataForComparisonEmployeeWise)
      }
      if (chartType == 'scatter') {
        this.getScatterComparisonEmployeeWiseGraph(this.graphDataForComparisonEmployeeWise)
      }
      if (this.ComparisonEmployeeWise[chartType] && typeof this.ComparisonEmployeeWise[chartType] === "object") {
        chartEmpTaskStatus.setOption(this.ComparisonEmployeeWise[chartType], true);
      }
    }
  }

  getBarComparisonEmployeeWiseGraph(data: any): echarts.EChartsOption {

    return {
      color: ['#F3820E'],
      tooltip: { trigger: 'axis' },
      xAxis: {
        type: 'category',
        data: data.map((ele: { empName: any; }) => ele.empName),
        name: 'Employee',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 6,
        },
        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: {
        type: 'value',
        splitLine: { show: false },
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
      }
      },
      series: [
        {
          name: 'Competency',
          data: data.map((ele: { score: any; }) => ele.score),
          type: 'bar',
          barWidth: 20,
          label: { show: true, position: 'top' ,fontSize: 9 }
        }
      ],
      // grid: {
      //   top: '15%',
      //   left: '1%',
      //   right: '0%',
      //   bottom: '10%',
      //   containLabel: true
      // },
      toolbox: {
        show: true,
        iconStyle: { borderColor: '#F3820E' }
      },
      legend: { bottom: 10 },
    };
  }

  getPieComparisonEmployeeWiseGraph(data: any): echarts.EChartsOption {
    const chartData = data.map((item: any) => ({
      value: item.wt,
      name: item.empName,
      achived: item.achived,
      score: item.score,
      wt: item.wt
    }));

    return {
      series: [
        {
          name: 'Competency Weightage',
          type: 'pie',
          radius: '50%',
          data: chartData,
          label: {
            show: true,
            formatter: '{c}',
            fontSize: 14,
            fontWeight: 'bold',
            color: '#000',
            position: 'inside',
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ],
      legend: { bottom: 10 },
    }
  }

  getLineComparisonEmployeeWiseGraph(data: any): echarts.EChartsOption {
    return {
      xAxis: {
        data: data.map((ele: { empName: any; }) => ele.empName),
        name: 'Employee',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 6,
        },
        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: { splitLine: { show: false },
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
      }},
      series: [
        {
          data: data.map((ele: { score: any; }) => ele.score),
          type: 'line',
          label: {
            show: true,
            position: 'bottom',
          }
        }
      ],
      legend: { bottom: 10 },
    }
  }

  getScatterComparisonEmployeeWiseGraph(data: any): echarts.EChartsOption {
    return {
      xAxis: {
        data: data.map((ele: { empName: any; }) => ele.empName),
        name: 'Employee',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 6,
        },
        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: { splitLine: { show: false },
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
      }},
      series: [
        {
          type: 'scatter',
          data: data.map((ele: { score: any; }) => ele.score),
          label: {show: true,position: 'bottom'}
        }
      ],
      legend: { bottom: 10 },
    }
  }

  onClickTableComparisonEmployeeWise() {
    this.ComparisonEmployeeWiseGraphType = ''
    this.showComparisonEmployeeWiseTble = true;
  }

  downloadComparisonEmpWiseGraph(){
   const year = this.sharedService.transformYearToFyFormat(this.selectedYearForGraphNineHRAdmin)
    
    this.pdfDownload.competencyGraphPDFdownload(
      'comparisonEmployeewiseGraph', // chartId
      'comparisonEmployeewiseTable', // tableId
      'Comparison Employee wise', // Title
      year, // Year
      null, // score
      this.selectedCompetencyName, // Competency Name
      this.comparisonEmployeesSelectMultiple.map((ele:any) => ele.itemName), // Employee Name
    ); 
  }

  //Year On Year Final Score Graph

  onSelectYearForGraphTenHrAdmin() {
    var year = this.competencySetupInformationForm.value.year?.split('-');
    if (year && year.length === 2) {
      const fromYear = year[0];
      const toYear = year[1];
      this.competencySetupInformationForm.controls['fromYear'].setValue(fromYear);
      this.competencySetupInformationForm.controls['toYear'].setValue(toYear);
    }
    this.getCompetencyYearonYear()
  }

  getCompetencyYearonYear() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      yearRange: [this.selectedYearForGraphTenHRAdmin],
      loggedInUserRole: this.loggedInUserRole
    };

    this.httpService.callPostService(this.config.getCompetencyYearOnYearfinal, request)
      .subscribe((response: any) => {
        
        this.selectedEmpYearonYear=[];
        if (response && Array.isArray(response.data)) {
          this.yearOnYearEmployeesFinal = response.data.map((employee: any) => ({
            id: employee.id,
            itemName: `${employee.firstName} ${employee.lastName}`
          }));
          this.yearOnYearEmployeesFinal = this.yearOnYearEmployeesFinal.sort((a: any, b: any) => a.itemName.localeCompare(b.itemName));
          if(this.yearOnYearEmployeesFinal.length!=0){
            this.selectedEmpYearonYear.push({id:this.yearOnYearEmployeesFinal[0].id,itemName:this.yearOnYearEmployeesFinal[0].itemName})
            this.YearOnYearFinalScoreGraph()
          }
        } else {
          this.yearOnYearEmployeesFinal = [];
        }
      });
  }
  onSelectAllYearOnYearFinalScore(item:any){
    this.selectedEmpYearonYear = item;
    this.YearOnYearFinalScoreGraph()
  }
  onDeselectAllYearOnYearFinalScore(){
    this.selectedEmpYearonYear = [];
  }
  logSelectedEmployee() {
    
    const selectedEmployee = this.yearOnYearEmployeesFinal.find(
      employee => employee.id === this.selectedEmpYearonYear
    );

    if (selectedEmployee) {
      this.selectedEmpYearonYear = selectedEmployee.id;
    }
    this.YearOnYearFinalScoreGraph()
  }

  YearOnYearFinalScoreGraph() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      employeeIds: this.selectedEmpYearonYear.map((ele: { id: any; }) => ele.id),
      managerCode: null,
      yearRanges: [this.selectedYearForCompetency],
    };

    this.httpService.callPostService(this.config.getCompetencyYearOnYearGraph, request)
      .subscribe((data: any) => {
        this.graphDataForYearOnYearFinalScore = []
        if(data.status){
          data.data.forEach((item: any) => {
            item.score.forEach((result: any) => {
              this.graphDataForYearOnYearFinalScore.push(result);
            });
          });
          this.YearOnYearFinalScore.bar = this.getBarYearOnYearFinalScoreGraph(this.graphDataForYearOnYearFinalScore);
          this.YearOnYearFinalScore.pie = this.getPieYearOnYearFinalScoreGraph(this.graphDataForYearOnYearFinalScore);
          this.YearOnYearFinalScore.line = this.getLineYearOnYearFinalScoreGraph(this.graphDataForYearOnYearFinalScore);
          this.YearOnYearFinalScore.scatter = this.getScatterYearOnYearFinalScoreGraph(this.graphDataForYearOnYearFinalScore);
          this.switchYearOnYearFinalScoreGraphType('line')
        }else{
          this.YearOnYearFinalScore.bar = this.getBarYearOnYearFinalScoreGraph(this.graphDataForYearOnYearFinalScore);
          this.YearOnYearFinalScore.pie = this.getPieYearOnYearFinalScoreGraph(this.graphDataForYearOnYearFinalScore);
          this.YearOnYearFinalScore.line = this.getLineYearOnYearFinalScoreGraph(this.graphDataForYearOnYearFinalScore);
          this.YearOnYearFinalScore.scatter = this.getScatterYearOnYearFinalScoreGraph(this.graphDataForYearOnYearFinalScore);
          this.switchYearOnYearFinalScoreGraphType('line')
        }
      });
  }

  switchYearOnYearFinalScoreGraphType(chartType: any) {
    this.YearOnYearFinalScoreGraphType = chartType;
    this.showYearOnYearFinalScoreTble = false;

    const dom = document.getElementById("YearOnYearScore") as HTMLDivElement
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (chartType == 'bar') {
        this.getBarYearOnYearFinalScoreGraph(this.graphDataForYearOnYearFinalScore)
      }
      if (chartType == 'pie') {
        this.getPieYearOnYearFinalScoreGraph(this.graphDataForYearOnYearFinalScore)
      }
      if (chartType == 'line') {
        this.getLineYearOnYearFinalScoreGraph(this.graphDataForYearOnYearFinalScore)
      }
      if (chartType == 'scatter') {
        this.getScatterYearOnYearFinalScoreGraph(this.graphDataForYearOnYearFinalScore)
      }
      if (this.YearOnYearFinalScore[chartType] && typeof this.YearOnYearFinalScore[chartType] === "object") {
        chartEmpTaskStatus.setOption(this.YearOnYearFinalScore[chartType], true);
      }
    }
  }

  getBarYearOnYearFinalScoreGraph(data: any): echarts.EChartsOption {
    return {
      color: ['#F3820E'],
      tooltip: { trigger: 'axis' },
      xAxis: {
        type: 'category',
        data: data.map((ele: { employeeName: any; }) => ele.employeeName),
        name: 'Employee',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 6,
        },
        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: {
        type: 'value',
        splitLine: { show: false },
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
      }
      },
      series: [
        {
          name: 'Competency Weightage',
          data: data.map((ele: { score: any; }) => ele.score),
          type: 'bar',
          barWidth: 20,
          label: { show: true, position: 'top' ,fontSize: 9 }
        }
      ],
      // grid: {
      //   top: '15%',
      //   left: '1%',
      //   right: '0%',
      //   bottom: '10%',
      //   containLabel: true
      // },
      toolbox: {
        show: true,
        iconStyle: { borderColor: '#F3820E' }
      },
      legend: { show:true,bottom: 0 },
    };
  }

  getPieYearOnYearFinalScoreGraph(data: any): echarts.EChartsOption {
    const chartData = data.map((item: any) => ({
      value: item.score,
      name: item.employeeName,
      score: item.score,
    }));

    return {
      series: [
        {
          name: 'Competency Weightage',
          type: 'pie',
          radius: '50%',
          data: chartData,
          label: {
            show: true,
            formatter: '{c}',
            fontSize: 14,
            fontWeight: 'bold',
            color: '#000',
            position: 'inside',
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ],
      legend: { show:true,bottom: 0 },
    }
  }

  getLineYearOnYearFinalScoreGraph(data: any): echarts.EChartsOption {
    return {
      xAxis: {
        data: data.map((ele: { employeeName: any; }) => ele.employeeName),
        name: 'Employee',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 6,
        },
        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: { splitLine: { show: false },
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
      }},
      series: [
        {
          name: 'Competency Weightage',
          data: data.map((ele: { score: any; }) => ele.score),
          type: 'line',
          label: {
            show: true,
            position: 'bottom',
          }
        }
      ],
      legend: { show:true,bottom: 0 },
    }
  }

  getScatterYearOnYearFinalScoreGraph(data: any): echarts.EChartsOption {
    return {
      xAxis: {
        data: data.map((ele: { employeeName: any; }) => ele.employeeName),
        name: 'Employee',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 6,
        },
        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: { splitLine: { show: false },
        name: 'Score',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
      }},
      series: [
        {
          name: 'Competency Weightage',
          type: 'scatter',
          data: data.map((ele: { score: any; }) => ele.score),
          label: {show: true,position: 'bottom'}
        }
      ],
      legend: { show:true,bottom: 0 },
    }
  }

  onClickTableYearOnYearFinalScore() {
    this.YearOnYearFinalScoreGraphType = ''
    this.showYearOnYearFinalScoreTble = true;
  }

   downloadYearFinalScoreGraph(){
   const year = this.sharedService.transformYearToFyFormat(this.selectedYearForGraphTenHRAdmin)
    
    this.pdfDownload.competencyGraphPDFdownload(
      'YearOnYearScore', // chartId
      'YearOnYearScoreTable', // tableId
      'Year On Year Final Score', // Title
      year, // Year
      null, // score
      null, // Competency Name
      this.selectedEmpYearonYear.map((ele:any) => ele.itemName), // Employee Name
    ); 
  }

  // Team Overview 

  onSelectYearForGraphFifthHrAdmin() {
    var year = this.competencySetupInformationForm.value.year?.split('-');
    if (year && year.length === 2) {
      const fromYear = year[0];
      const toYear = year[1];
      this.competencySetupInformationForm.controls['fromYear'].setValue(fromYear);
      this.competencySetupInformationForm.controls['toYear'].setValue(toYear);
    }
    this.competencyWiseEmployeeGraph()
  }

  getCompetencyNameForEmployeeTableTeamGraph() {
    var id
    if(this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
      || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD'){
      id = this.loggedInCompanyMDCode
    }else{
      id= this.loggedInUserEmpCode
    }
    this.httpService.callGetService(
      `${this.config.getCompetencyNamesForCompEmployee}${this.loggedInUserCompanyID}/${this.selectedYearForCompetency}`
    ).subscribe((response: any) => {
      
      this.SelectCompetencyDropdownListForEmployeeTableTeamGraphView =[];
      if (response.status) {
        response?.data?.forEach((ele: any) => {
          let obj = {
            id: ele,
            itemName: ele,
          }
          this.SelectCompetencyDropdownListForEmployeeTableTeamGraphView.push(obj);
        });
        this.SelectCompetencyDropdownListForEmployeeTableTeamGraphView = this.SelectCompetencyDropdownListForEmployeeTableTeamGraphView.sort((a: any, b: any) => a.itemName.localeCompare(b.itemName));
        
        if(this.SelectCompetencyDropdownListForEmployeeTableTeamGraphView.length!=0){
          this.selectedCompetencyForEmployeeTableTeamGraphView = this.SelectCompetencyDropdownListForEmployeeTableTeamGraphView[0].id
          this.competencyWiseEmployeeGraph();
        }
      } else {
      }
    }, (error) => {
    });
  }
  getListOfEmployeeManager(){
    var id
    if(this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
      || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD'){
      id = this.loggedInCompanyMDCode
    }else{
      id= this.loggedInUserEmpCode
    }
    this.httpService.callGetService(
      `${this.config.getListOfEmployeeManager}${this.loggedInUserCompanyID}/${this.selectedYearForCompetency}/${id}`
    ).subscribe((response: any) => {
      
      this.SelectCompetencyDropdownListForEmployeeTableTeamGraphView =[];
      if (response.status) {
        response?.data?.forEach((ele: any) => {
          let obj = {
            id: ele,
            itemName: ele,
          }
          this.SelectCompetencyDropdownListForEmployeeTableTeamGraphView.push(obj);
        });
        this.SelectCompetencyDropdownListForEmployeeTableTeamGraphView = this.SelectCompetencyDropdownListForEmployeeTableTeamGraphView.sort((a: any, b: any) => a.itemName.localeCompare(b.itemName));
        
        if(this.SelectCompetencyDropdownListForEmployeeTableTeamGraphView.length!=0){
          this.selectedCompetencyForEmployeeTableTeamGraphView = this.SelectCompetencyDropdownListForEmployeeTableTeamGraphView[0].id
          this.competencyWiseEmployeeGraph();
        }
      } else {
      }
    }, (error) => {
    });
  }

  //last two graphs 

  onSelectAllComparisonEmp(items: any) {
  }

  onComparisonEmpDeSelect(item: any) {
  }

  onDeSelectAllComparisonEmp(items: any) {
  }


  //manager view Graph change due to Api Change 

  getEmployeeForManagerGraphs() {
    
    this.httpService.callGetService(this.config.competencyEmployeeUnderManager + this.selectedManagerDashboardId + "/" + this.selectedYearForCompetency)
      .subscribe((response: any) => {
        this.managerViewEmpGraphList = (response?.data || []).map((employee: any) => ({
          id: employee.id,
          fullName: `${employee.firstName} ${employee.lastName}`.trim()
        }));
      }, (error) => {
      });
  }

  onSelectYearForManagerGraphCompetencyWise() {
    var year = this.competencySetupInformationForm.value.year?.split('-');
    if (year && year.length === 2) {
      const fromYear = year[0];
      const toYear = year[1];
      this.competencySetupInformationForm.controls['fromYear'].setValue(fromYear);
      this.competencySetupInformationForm.controls['toYear'].setValue(toYear);
    }
    this.getCompetencyNameForManagerGraphView()
  }

  getCompetencyNameForManagerGraphView() {
    this.httpService.callGetService(
      `${this.config.getCompetencyNamesForCompEmployee}${this.loggedInUserCompanyID}`
    ).subscribe((response: any) => {
      if (response.status) {
        this.managerEmpGraphListView = response?.data || []; // Store competency names in the property
      } else {
      }
    }, (error) => {
    });
  }

  selectManagerGraphViewEmp(selectedId: number) {
    this.selectedManagerGraphEmpId = selectedId;
    this.getCompetencyWiseEmployeeManagerView()
  }





  getCompetencyWiseEmployeeManagerView() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      competencyName: this.selectedManagerGraphEmpId,
      employeeId: null,
      managerCode: this.loggedInUserEmpCode,
      subCompetencyId: null,
      yearRange: this.selectedYearForMnagerGraphCompetencyWiseEmp,
    };

    this.httpService.callPostService(this.config.getManagerGraphCompetencyWiseEmpManagerView, request)
      .subscribe(
        (response: any) => {

          if (response?.data) {
            this.processCompetencyWiseEmployeeManagerViewData(response.data);
          } else {
          }
        },
        (error) => {
        }
      );
  }

  processCompetencyWiseEmployeeManagerViewData(data: any[]) {
    this.managerEmpGraphTableData = data;
  }


  //manager Ratingwise Graph


  onSelectYearForGraphManagerViewRatingWise() {
    var year = this.competencySetupInformationForm.value.year?.split('-');
    if (year && year.length === 2) {
      const fromYear = year[0];
      const toYear = year[1];
      this.competencySetupInformationForm.controls['fromYear'].setValue(fromYear);
      this.competencySetupInformationForm.controls['toYear'].setValue(toYear);
    }
    this.getCompetencyRatingWiseGraphManager()
  }

  getCompetencyRatingWiseGraphManager() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      employeeId: null,
      managerCode: this.loggedInUserEmpCode,
      yearRange: this.selectedYearForGraphManagerViewRatingWise,
    };

    this.httpService.callPostService(this.config.getManagerGraphCompetencyWiseRatingWise, request)
      .subscribe(
        (response: any) => {
          const data = Array.isArray(response?.data) ? response.data : [];
          this.CompetencyRatingwiseGraphBar(data);
        },
        (error) => {
        }
      );
  }

  CompetencyRatingwiseGraphBar(data: any[]) {
    const dom = document.getElementById('CompetencyGraphRatingwiseManagerView');
    if (!dom) {
      return;
    }
    const myChart = echarts.init(dom);
    if (!Array.isArray(data)) {
      return;
    }
    const categories = data.map(item => item.rating || 'Unknown');
    const values = data.map(item => item.empCount || 0);
    const option = {
      title: {
        text: 'Competency Rating Employee Count',
        left: 'center'
      },
      xAxis: {
        type: 'category',
        data: categories
      },
      yAxis: {
        type: 'value',
        splitLine: { show: false }
      },
      series: [
        {
          data: values,
          type: 'bar',
          label: {
            show: true,
            position: 'top',
            formatter: '{c}',
            fontSize: 12,
            fontWeight: 'bold',
            color: '#000',
          },
          itemStyle: {
            color: '#F3820E'
          }
        }
      ]
    };

    if (option && typeof option === 'object') {
      myChart.setOption(option, true);
    }
  }

  //secondlast graph for managerview



  onSelectYearForGraphManagerViewComparison() {
    var year = this.competencySetupInformationForm.value.year?.split('-');
    if (year && year.length === 2) {
      const fromYear = year[0];
      const toYear = year[1];
      this.competencySetupInformationForm.controls['fromYear'].setValue(fromYear);
      this.competencySetupInformationForm.controls['toYear'].setValue(toYear);
    }
    this.getComparisonEmployeeWiseListManagerViewGraph()
  }


  getComparisonEmployeeWiseListManagerViewGraph() {
    this.httpService.callGetService(this.config.getCompetencyEmpList + this.loggedInUserCompanyID + '/' + this.selectedYearForGraphMangerViewComparison)
      .subscribe((response: any) => {
        if (response?.status) {
          this.ComparisonEmployeeWiseListManagerViewData = response.data;
        }
      }, (error: any) => {
      });
  }

  onCompSelectManagerView(event: any) {
    this.selectedCompetencyForComparison = event;
    this.comparisonEmployeesSelectionManagerView()
  }




  comparisonEmployeesSelectionManagerView() {
    this.httpService.callGetService(this.config.getManagerListofGraph + this.loggedInUserCompanyID + '/' + this.selectedYearForGraphNineHRAdmin + '/' + this.selectedCompetencyName + '/' + this.loggedInUserEmpCode)
      .subscribe((response: any) => {

        if (response && response.data && Array.isArray(response.data)) {
          this.employeesListComparisonSelected = response.data.map((employee: any) => {
            return {
              itemName: `${employee.firstName} ${employee.lastName}`,
              id: employee.id
            };
          });
          this.employeesListComparisonSelected = this.employeesListComparisonSelected.sort((a: any, b: any) => a.itemName.localeCompare(b.itemName));
        } else {
          this.employeesListComparisonSelected = [];
        }
        if(this.employeesListComparisonSelected.length!=0){
          this.comparisonEmployeesSelectMultiple = [];
          this.comparisonEmployeesSelectMultiple.push({id:this.employeesListComparisonSelected[0].id,itemName:this.employeesListComparisonSelected[0].itemName});
          this.comparisonEmpIdsForSecondLast.push(this.comparisonEmployeesSelectMultiple);
          this.getComparisonEmployeeWiseGraph();
        } else {
          this.employeesListComparisonSelected = [];
        }
      }, (error: any) => {
      });
  }


  onComparisonEmpSelectManagerView(selectedItems: any) {
    this.comparisonEmpIdsForSecondLastManagerView = [];

    if (Array.isArray(selectedItems) && selectedItems.length > 0) {
      selectedItems.forEach((item: any) => {
        if (item && item.id) {
          this.comparisonEmpIdsForSecondLastManagerView.push(item.id);
        } else {
        }
      });
    } else if (selectedItems && selectedItems.id) {
      this.comparisonEmpIdsForSecondLastManagerView.push(selectedItems.id);
    } else {
    }
    this.getCompetencyComparisonGraphManagerView()
  }



  // comparisongraphmanagerview

  getCompetencyComparisonGraphManagerView() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      competencyName: this.selectedCompetencyForComparison,
      employeeId: this.comparisonEmpIdsForSecondLastManagerView,
      managerCode: null,
      yearRange: this.selectedYearForGraphMangerViewComparison,
    };

    this.httpService.callPostService(this.config.getManagerGraphComparisionYear, request)
      .subscribe({
        next: (response: any) => {
          if (response?.data && Array.isArray(response.data)) {
            this.ComparisonGraphManagerView(response.data);
          } else {
          }
        },
        error: (error: any) => {
        }
      });
  }



  ComparisonGraphManagerView(data: any[]) {
    const dom = document.getElementById("ComparisionManagerView");

    if (!dom) {
      return;
    }

    const myChart1 = echarts.init(dom);

    if (!Array.isArray(data)) {
      return;
    }

    const categories = data.map(item => item.empName);
    const values = data.map(item => item.score);

    const option2 = {
      xAxis: {
        type: 'category',
        data: categories
      },
      yAxis: {
        type: 'value',
        splitLine: { show: false }
      },
      series: [
        {
          data: values, // Series data
          type: 'bar',
          label: {
            show: true,
            position: 'top',
            formatter: '{c}',
            fontSize: 12,
            fontWeight: 'bold',
            color: '#000',
          },
          itemStyle: {
            color: '#F3820E' // Bar color
          }
        }
      ]
    };

    myChart1.setOption(option2, true);
  }

  //last graph manager view
  getBandsByDepartment() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "department": this.selectedFunctionsForHrAdmin.map((ele: { id: any; }) => ele.id)
    }
    this.httpService.callPostService(this.config.getBandsByDepartment, request).subscribe((result: any) => {
      if (result && result.status) {
        this.bandListHrAdmin = result.data.map((ele: any) => ({
          id: ele,
          itemName: ele
        }));
        this.bandListHrAdmin = this.bandListHrAdmin.sort((a: { itemName: any; }, b: { itemName: any; }) => a.itemName.localeCompare(b.itemName));
      } else {
        this.bandListHrAdmin = [];
      }
    })
  }
  getGradesByDepartment() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "department": this.selectedFunctionsForHrAdmin.map((ele: { id: any; }) => ele.id)
    }
    this.httpService.callPostService(this.config.getGradesByDepartment, request).subscribe((result: any) => {
      if (result && result.status) {
        this.bandListHrAdmin = result.data.map((ele: any) => ({
          id: ele,
          itemName: ele
        }));
        this.bandListHrAdmin = this.bandListHrAdmin.sort((a: { itemName: any; }, b: { itemName: any; }) => a.itemName.localeCompare(b.itemName));
      } else {
        this.bandListHrAdmin = [];
      }
    })
  }
  getListOfDepartmentsOfComp: any = [];
  getDepartmentsByCompany() {
    this.httpService.callGetService(this.config.getDepartmentsByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfDepartmentsOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          itemName: ele,
        }
        this.getListOfDepartmentsOfComp.push(obj);
      });
      this.getListOfDepartmentsOfComp = this.getListOfDepartmentsOfComp.sort((a: { itemName: any; }, b: { itemName: any; }) => a.itemName.localeCompare(b.itemName));
    })
  }
  compentencySetupYearList:any=[];
  getCompetencySetupYearOfCompany() {
    this.httpService.callGetService(this.config.getCompetencySetupYearOfCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.compentencySetupYearList = [];
      
      data?.data?.forEach((ele: any) => {
        let obj = {
          year: ele.yearRange
        }
        this.compentencySetupYearList.push(obj);
      });
      this.compentencySetupYearList?.forEach((ele: any) => {
        const currentYear = new Date().getFullYear();
        let yearValue = '';
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth(); 
        if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
          yearValue = `${currentYear}-${currentYear}`;
        } else {
          yearValue = `${currentYear}-${currentYear + 1}`;
          if(this.loggedInCompanyFiscalyear === 'Apr_Mar'){
            if(currentMonth<3){
              yearValue = `${currentYear-1}-${currentYear}`;
            }else{
              yearValue = `${currentYear}-${currentYear + 1}`;
            }
          }
          if(this.loggedInCompanyFiscalyear === 'July_Jun'){
            if(currentMonth<6){
              yearValue = `${currentYear-1}-${currentYear}`;
            }else{
              yearValue = `${currentYear}-${currentYear + 1}`;
            }
          }
          if(this.loggedInCompanyFiscalyear === 'Oct_Sep'){
            if(currentMonth<9){
              yearValue = `${currentYear-1}-${currentYear}`;
            }else{
              yearValue = `${currentYear}-${currentYear + 1}`;
            }
          }
        }
        if (ele?.year == yearValue) {
          this.selectedYearForCompetency = ele?.year;
          this.selectedYearForGraphOneHRAdmin = ele?.year
          this.selectedYearForGraphTwoHRAdmin = ele?.year
          this.selectedYearForGraphFifthHRAdmin = ele?.year
          this.selectedYearForGraphSix = ele?.year
          this.selectedYearForGraphNineHRAdmin = ele?.year
          this.selectedYearForGraphTenHRAdmin = ele?.year
          var test = ele?.year?.split('-');
          this.fromYear = test[0];
          this.toYear = test[1];
          if (this.loggedInCompanyFiscalyear != null) {
            const currentDate = new Date();
            const currentMonth = currentDate.getMonth(); // 0 for January, 11 for December
            const currentYear = currentDate.getFullYear();
            var endMonth = this.loggedInCompanyFiscalyear?.split('_')
            const monthToCheck = new Date( this.toYear, this.getMonthIndex(this.sharedService.transform(endMonth[1])), 30);
            this.isShowAddBtn = currentDate < monthToCheck;
          } else {
            this.isShowAddBtn = false;
          }
        }
      });
      this.getEmployeeUnderManager()
      this.getCompetencySetup();
      this.getAllFunctionsByYearRangeReport();
      this.getDepartmentsByCompany();
      if (this.selectedTypeTabName === 'My Competency') {
        this.getAllEmployeesUnderManagerView();
      } else if (this.selectedTypeTabName === 'Competency Master') {
        this.getAllCompetencyList();
      }
      else if (this.selectedTypeTabName === 'Team Competency') {
        this.getCompetencyByManagerTeamList();
      }
      if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
        || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
          this.getManagerListDashboard();
      }
      if (this.loggedInUserRole === 'Employee') {
        this.selectedEmployeeDashboardId = this.loggedInUserId;
        this.selectedEmployeeDashboardFullName = this.loggedInUserName;
        this.getLoginUserGraphData();
      }
      this.getGlobalSummary()
    })
  }
  onSelectSizeOfCompetency() {
    if (this.selectedTypeTabName === 'My Competency') {
      this.getAllEmployeesUnderManagerView();
    } else if (this.selectedTypeTabName === 'Competency Master') {
      this.getAllCompetencyList();
    }
    else if (this.selectedTypeTabName === 'Team Competency') {
      this.getCompetencyByManagerTeamList();
    }
  }
  onClickCompetencyCard(popupName:any){
    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.data = {
      btn2: 'OK',
      popupName: popupName,
      year: this.selectedYearForCompetency,
      setupGradeBrand: this.setupGradeBrand
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(CompetecnyDashboardDetailsPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  reportingManagerName:any=null;
  getUserByID() {
    this.httpService.callGetService(this.config.getEmployeeById + this.selectedEmployeeDashboardId).subscribe((data: any) => {
      if(data?.data?.reportingManager!=null){
        this.reportingManagerName = data?.data?.reportingManager?.firstName+' '+data?.data?.reportingManager?.lastName;
      }
    })
  }
  onSearchReport(searchStringReport:any){
    var search = ''
    this.searchStringReport = searchStringReport;
    if (searchStringReport == '') {
      this.searchStringReport = null;
      if(this.loggedInUserRole == 'HR Admin' ||  this.loggedInUserRole == 'Super Admin' || 
        this.loggedInUserRole == 'MD' ||  this.loggedInUserRole == 'PHI Admin'){
        this.submitData();
      }
      if(this.loggedInUserRole == 'Manager' ||  this.loggedInUserRole == 'HOD'){
        this.submitManagerDataReport();
      }
      if(this.loggedInUserRole == 'Emoloyee'){
        this.submitEmployeeReportData();
      }      
      return;
    }
    if (searchStringReport.length > 1) {
      setTimeout(() => {
        search = searchStringReport;
        if (search.length == searchStringReport.length) {
          setTimeout(() => {
            if(this.loggedInUserRole == 'HR Admin' ||  this.loggedInUserRole == 'Super Admin' || 
              this.loggedInUserRole == 'MD' ||  this.loggedInUserRole == 'PHI Admin'){
              this.submitData();
            }
            if(this.loggedInUserRole == 'Manager' ||  this.loggedInUserRole == 'HOD'){
              this.submitManagerDataReport();
            }
            if(this.loggedInUserRole == 'Emoloyee'){
              this.submitEmployeeReportData();
            }          },
            500);
        }
      },
        1500);
    }
  }
  onSelectSizeOfCompetencyReport(){
    if(this.loggedInUserRole == 'HR Admin' ||  this.loggedInUserRole == 'Super Admin' || 
      this.loggedInUserRole == 'MD' ||  this.loggedInUserRole == 'PHI Admin'){
      this.submitData();
    }
    if(this.loggedInUserRole == 'Manager' ||  this.loggedInUserRole == 'HOD'){
      this.submitManagerDataReport();
    }
    if(this.loggedInUserRole == 'Emoloyee'){
      this.submitEmployeeReportData();
    }
  }
  checkLengthOfField(string: any) {
    if (string.length > 254) {
      this.toastr.warning('The text cannot exceed 255 characters.', '', {
        timeOut: 3000,
      });
    }
  }
}